// VHRP Connect — translations for 8 Indian languages
export const DEFAULT_LANG = "en";

export const LANGUAGES = [
  { code: "en", native: "English", english: "English" },
  { code: "hi", native: "हिन्दी", english: "Hindi" },
  { code: "ta", native: "தமிழ்", english: "Tamil" },
  { code: "ml", native: "മലയാളം", english: "Malayalam" },
  { code: "te", native: "తెలుగు", english: "Telugu" },
  { code: "kn", native: "ಕನ್ನಡ", english: "Kannada" },
  { code: "bn", native: "বাংলা", english: "Bengali" },
  { code: "mr", native: "मराठी", english: "Marathi" },
];

// Maps backend benefit strings -> translation keys
export const BENEFIT_KEYS = {
  "Digital Membership ID": "ben1",
  "1-year validity": "ben2",
  "Newsletter updates": "ben3",
  "Event invites": "ben4",
  "Volunteer opportunities": "ben5",
  "Everything in Friend": "ben6",
  "Priority grievance response": "ben7",
  "Local chapter access": "ben8",
  "Everything in Associate": "ben9",
  "State-level events": "ben10",
  "Recognition certificate": "ben11",
  "Everything in Active": "ben12",
  "National conclave access": "ben13",
  "Direct leadership contact": "ben14",
  "Everything in Patron": "ben15",
  "Lifetime recognition": "ben16",
  "Exclusive founder events": "ben17",
  "Personal welcome by leadership": "ben18",
};

// Maps backend tier labels -> translation keys
export const TIER_KEYS = {
  Supporter: "tierSupporter",
  Friend: "tierFriend",
  Associate: "tierAssociate",
  "Active Member": "tierActive",
  Patron: "tierPatron",
  "Founder Circle": "tierFounder",
};

export const translations = {
  en: {
    orgName: "Vishwa Hindu Raksha Parishad",
    motto: "यतो धर्मः ततो जयः",
    back: "Back",
    loadError: "Could not load data. Please check your connection.",
    retry: "Retry",
    newsEmpty: "No updates yet. Check back soon!",
    feedbackMenu: "Send Feedback",
    feedbackTitle: "Send Feedback",
    feedbackSub: "Found a bug or have a suggestion? We'd love to hear from you.",
    feedbackPlaceholder: "Describe the issue or share your idea…",
    feedbackContactPh: "Your email or phone (optional)",
    feedbackSend: "Send Feedback",
    feedbackThanks: "Thank you! Your feedback has been received.",
    feedbackEmpty: "Please write a message before sending.",
    newBadge: "NEW",
    videosTitle: "Videos",
    videosEmpty: "No videos yet — check our YouTube channel",
    desigMember: "Member",
    desigGeneral: "General Member",
    contactHQ: "For other responsible memberships, kindly contact the Head Office",
    promoTill: "Only till 4th October",
    inviteCopied: "Invite copied — paste it in WhatsApp",
    share: "Share",
    copied: "Copied to clipboard",
    photoVerifying: "AI is verifying your photo…",
    photoRejected: "Photo rejected",
    photoRequired: "Please add your photo to continue",
    aadhaarFront: "Aadhaar Front Photo *",
    aadhaarBack: "Aadhaar Back Photo *",
    aadhaarPhotosReq: "Aadhaar front & back photos are required",
    aadhaarAdminOnly: "Visible only to VHRP admins",
    tabHome: "Home",
    tabMembership: "Membership",
    tabGrievance: "Grievance",
    tabProfile: "Profile",
    langTitle: "Choose your language",
    langSubtitle: "अपनी भाषा चुनें • Select the language you're most comfortable with",
    langContinue: "Continue",
    loginTagline: "Membership • Grievance • Seva",
    loginGoogle: "Continue with Google",
    loginLegal: "By continuing you agree to VHRP's Terms\nand privacy policy.",
    greet: "Namaste 🙏",
    defaultMember: "Member",
    heroTitle: "Protection, Empowerment & Progress of Society",
    heroSub: "Founded by Shri Gopal Rai on the auspicious occasion of Ram Navami",
    heroCta: "Become a Member",
    quickGrievance: "Grievance",
    quickPlans: "Membership",
    quickAbout: "About",
    quickContact: "Contact",
    unlockTitle: "Unlock Membership",
    unlockTitlePending: "Complete Membership",
    unlockSub: "Join VHRP and get your official digital ID card instantly.",
    unlockSubPending: "You're almost there — complete payment to receive your digital ID card.",
    founderMsgTitle: "Founder's Message",
    founderName: "Shri Gopal Rai",
    founderRole: "International President (VHRP)",
    founderQuote: "Our objective is to empower the Hindu society, protect our culture and promote the feeling of unity.",
    galleryTitle: "Photo Gallery",
    latestUpdates: "Latest News & Events",
    statPrograms: "Awareness Programs",
    statRelief: "Disaster Relief Given",
    statCenters: "Training Centers",
    aboutKicker: "ABOUT US",
    aboutTitle: "Vishwa Hindu\nRaksha Parishad",
    aboutHeroSub: "A religious and social organization dedicated to the protection, empowerment and progress of society.",
    aboutStoryTitle: "Our Story",
    aboutStory: "The Vishwa Hindu Raksha Parishad (VHRP) is a religious and social organization founded by Shri Gopal Rai on the auspicious occasion of Ram Navami. During his travels across the country, Shri Gopal Rai realized that the development of Hindu society was not progressing as it should. To change this situation, he established VHRP to present Hinduism and society in a stronger and more organized form.",
    objectivesTitle: "Our Main Objectives",
    obj1: "Making India a Hindu nation",
    obj2: "Ending casteism",
    obj3: "Prohibiting child marriage",
    obj4: "Giving education to poor children",
    obj5: "Banning cow slaughter houses",
    obj6: "Facilitating marriage of girls from economically weaker backgrounds",
    purposeTitle: "Our Purpose",
    purposeBody: "VHRP protects the heritage, culture and values of Hinduism, preserves traditions, and creates a harmonious and strong society by resolving social issues.",
    coreValuesTitle: "Our Core Values",
    coreValuesBody: "We strengthen the unity of society through service and culture. We believe in peaceful coexistence, embracing diversity with truth, compassion and tolerance.",
    initiativesTitle: "Impactful Initiatives",
    initiativesBody: "\"Sanskriti Raksha Yojana\" preserves traditions, \"Child Development Center\" empowers youth, \"Seva Kendra\" provides health services, and \"Global Hindu Campaign\" enhances unity.",
    achievementsTitle: "Our Achievements",
    achievementsBody: "500+ awareness programs conducted, disaster relief provided to 50,000+ people, training centers created for youth, and campaigns run to preserve ancient temples and traditions.",
    founderSecTitle: "Our Founder",
    founderDesc: "The International President of VHRP, Shri Gopal Rai, is renowned for his leadership and dedication towards society. His objective is to empower society, protect the culture and promote unity.",
    joinCta: "Join VHRP",
    contactTitle: "Contact Us",
    contactIntro: "Have any questions? Reach out to VHRP for support, membership or partnerships.",
    contactCallLabel: "Phone (Office)",
    contactMobileLabel: "Mobile / Helpline",
    contactEmailLabel: "Email",
    contactWebsiteLabel: "Website",
    contactAddressLabel: "Head Office",
    memTitle: "Choose Membership",
    memSubtitle: "Support VHRP's mission. Pick a tier that suits you.",
    perYear: "/ year",
    memContinue: "Continue to Registration",
    memUpgrade: "Upgrade / Renew",
    tierSupporter: "Supporter",
    tierFriend: "Friend",
    tierAssociate: "Associate",
    tierActive: "Active Member",
    tierPatron: "Patron",
    tierFounder: "Founder Circle",
    ben1: "Digital Membership ID",
    ben2: "1-year validity",
    ben3: "Newsletter updates",
    ben4: "Event invites",
    ben5: "Volunteer opportunities",
    ben6: "Everything in Friend",
    ben7: "Priority grievance response",
    ben8: "Local chapter access",
    ben9: "Everything in Associate",
    ben10: "State-level events",
    ben11: "Recognition certificate",
    ben12: "Everything in Active",
    ben13: "National conclave access",
    ben14: "Direct leadership contact",
    ben15: "Everything in Patron",
    ben16: "Lifetime recognition",
    ben17: "Exclusive founder events",
    ben18: "Personal welcome by leadership",
    grvTitle: "File a Grievance",
    grvMembersOnlyTitle: "Members only",
    grvMembersOnlyBody: "Filing a grievance is a benefit for active VHRP members. Become a member to raise and track your grievances.",
    grvBecomeMember: "Become a member",
    grvSubtitle: "Report an issue or complaint to VHRP.",
    grvSubject: "Subject *",
    grvSubjectPh: "Brief title",
    grvCategory: "Category",
    grvLocation: "Location (city, state)",
    grvLocationPh: "e.g. Lucknow, Uttar Pradesh",
    grvDesc: "Describe the issue *",
    grvDescPh: "Please share full context — what happened, when, and who was involved.",
    grvSubmit: "Submit Complaint",
    grvFillReq: "Please fill subject and description",
    grvOkTitle: "Complaint received",
    grvOkSub: "Your ticket has been logged. Our team will reach out within 3 working days.",
    grvTicket: "TICKET ID",
    grvAnother: "File another complaint",
    catLand: "Land Dispute",
    catCorruption: "Corruption",
    catPublic: "Public Service",
    catWomen: "Women Safety",
    catCommunal: "Communal Issue",
    catOther: "Other",
    regTitle: "Membership Details",
    regTierLabel: "Tier",
    regPhotoAdd: "Add photo",
    regPhotoHint: "Passport photo (3:4)\nUsed on your Digital ID Card.",
    regFullName: "Full Name *",
    regFather: "Father's / Guardian's Name *",
    regAddress: "Address *",
    regPhone: "Phone *",
    regDob: "DOB *",
    regEmail: "Email",
    regDesignation: "Designation",
    regBlood: "Blood Group",
    regAadhaar: "Aadhaar Number *",
    regPay: "Proceed to Pay",
    regFillReq: "Please fill all required fields",
    regPhotoPerm: "Photo permission needed",
    regDefaultDesig: "General Member",
    payTitle: "Payment",
    payCreating: "Creating your order…",
    payAmount: "Amount payable",
    payDemo: "Demo mode: Razorpay keys not configured. Tapping \"Pay\" will simulate a successful payment for prototype.",
    paySimulate: "Simulate Payment",
    payNow: "Pay Now",
    paySecured: "🔒 Secured by Razorpay",
    payNonRefundable: "By continuing, you agree that the membership contribution is non-refundable.",
    payProcessing: "Processing payment…",
    payFailTitle: "Payment failed",
    payFailSub: "Something went wrong. Try again.",
    payBack: "Go Back",
    payOkTitle: "You're a Member! 🎉",
    payOkSub: "Payment received. Your Digital ID Card is ready.",
    payViewCard: "View my Digital Card",
    cardHeadTitle: "My Digital ID",
    cardScan: "SCAN TO VERIFY",
    cardScanHint: "Verifiers can scan this code to confirm your active membership.",
    cardEmptyTitle: "No active membership",
    cardEmptySub: "Complete registration to get your Digital ID card.",
    cardGet: "Get Membership",
    dMembershipId: "Membership ID",
    dTier: "Tier",
    dFullName: "Full name",
    dFather: "Father's name",
    dDob: "Date of birth",
    dPhone: "Phone",
    dAddress: "Address",
    cardShareMsg: "I'm now a member of Vishwa Hindu Raksha Parishad! Membership ID:",
    cardOfficialSub: "Digital Membership Card",
    cardValidUntil: "Valid Until",
    cardSo: "S/o",
    cardBlood: "Blood",
    cardCity: "City",
    cardState: "State",
    profCardSection: "My Digital Card",
    profBecome: "Become a Member",
    profBecomeSub: "Get your official digital ID card in minutes.",
    profComplaints: "My Complaints",
    profMore: "More",
    profAboutItem: "About VHRP",
    profContactItem: "Contact Us",
    profPrivacy: "Privacy Policy",
    profDelete: "Delete Account",
    profDeleteWarn: "This permanently deletes your account, membership, digital ID card, Aadhaar details and complaints. Payment records are retained for legal accounting. This cannot be undone.",
    profDeleteBtn: "Delete permanently",
    profDeleteCancel: "Cancel",
    profLanguageItem: "Language / भाषा",
    profLogout: "Log out",
    newsHeader: "News",
    verifyTile: "Verify a Member",
    verifyTitle: "Member Verification",
    verifyIntro: "Scan a member's QR code to instantly confirm their membership. The camera is used only for scanning.",
    verifyEnable: "Enable Camera & Scan",
    verifyDeniedMsg: "Camera access was denied. You can type the Membership ID below, or enable the camera in Settings.",
    verifyOpenSettings: "Open Settings",
    verifyScanHint: "Point the camera at the member's QR code",
    verifyManual: "Or enter Membership ID",
    verifyCheck: "Verify",
    verifyChecking: "Verifying…",
    verifyValid: "Valid Member",
    verifyExpired: "Membership Expired",
    verifyInvalid: "Not a Valid Member",
    verifyDeactivated: "Membership Deactivated",
    verifyNotFound: "No member found with this ID.",
    verifyScanAgain: "Verify another",
    verifyWebHint: "Camera scanning works in the mobile app. Enter the Membership ID manually below.",
    cardSave: "Save Image",
    cardShare: "Share",
    cardSaved: "Card image saved to your gallery",
    cardSaveFailed: "Could not save the card",
    cardPermPhotos: "Allow photo access to save your card to the gallery",
    trackTitle: "Complaint Status",
    stReceived: "Received",
    stInReview: "In Review",
    stResolved: "Resolved",
    trackDesc: "Description",
    trackLocation: "Location",
    eventsTitle: "Upcoming Events",
    eventsEmpty: "No upcoming events right now. Check back soon!",
    rsvpGo: "I'll Attend",
    rsvpGoing: "You're Going ✓",
    attending: "attending",
    seeAll: "See all",
    renewSoonTitle: "Membership expiring soon",
    renewSoonBody: "Your membership expires in {days} days. Renew to keep your digital ID active.",
    renewExpiredTitle: "Membership expired",
    renewExpiredBody: "Your membership has expired. Renew now to reactivate your digital ID.",
    renewCta: "Renew Now",
    evToday: "is today!",
    evTomorrow: "is tomorrow!",
    regCity: "City *",
    regState: "State *",
    regCountry: "Country",
    regAssembly: "Vidhan Sabha (Assembly Constituency) *",
    regAssemblyPh: "Type to search your constituency",
    regAssemblyReq: "Please select your Vidhan Sabha (assembly constituency)",
    regSocial: "Social Media Link",
    regSocialPh: "e.g. https://facebook.com/yourprofile",
    regAadhaarInvalid: "Enter a valid 12-digit Aadhaar number",
    otpSend: "Send OTP",
    otpSent: "OTP sent to your number",
    otpEnterPh: "6-digit OTP",
    otpVerify: "Verify",
    otpVerified: "Verified ✓",
    otpDemoNote: "Demo mode — your OTP is:",
    otpRequired: "Please verify your phone number with OTP first",
    dirTile: "Member Directory",
    dirTotalLabel: "Registered Members",
    dirSearchPh: "Search name, city or state…",
    dirAll: "All",
    dirIndia: "India",
    dirIntl: "International",
    dirCityAll: "All cities",
    dirMoreCities: "More cities",
    dirPickCity: "Select a city",
    dirCitySearchPh: "Search cities…",
    dirOtherRegion: "Other",
    dirLockedTitle: "Members Only",
    dirLockedSub: "The member directory is available to active members. Get your membership to connect with VHRP members across India and abroad.",
    dirEmpty: "No members found",
    grvPhotos: "Attach photos as proof (optional, max 3)",
    trackPhotos: "Attached Photos",
  },
  hi: {
    orgName: "विश्व हिन्दू रक्षा परिषद",
    motto: "यतो धर्मः ततो जयः",
    back: "वापस",
    loadError: "डेटा लोड नहीं हो सका। कृपया अपना कनेक्शन जांचें।",
    retry: "पुनः प्रयास करें",
    newBadge: "नया",
    videosTitle: "वीडियो",
    videosEmpty: "अभी कोई वीडियो नहीं — हमारा YouTube चैनल देखें",
    desigMember: "सदस्य",
    desigGeneral: "सामान्य सदस्य",
    contactHQ: "अन्य जिम्मेदार सदस्यता के लिए कृपया प्रधान कार्यालय से संपर्क करें",
    promoTill: "केवल 4 अक्टूबर तक",
    inviteCopied: "निमंत्रण कॉपी हुआ — WhatsApp में पेस्ट करें",
    share: "साझा करें",
    copied: "क्लिपबोर्ड पर कॉपी हुआ",
    photoVerifying: "AI आपकी फोटो सत्यापित कर रहा है…",
    photoRejected: "फोटो अस्वीकृत",
    photoRequired: "आगे बढ़ने के लिए कृपया अपनी फोटो जोड़ें",
    aadhaarFront: "आधार सामने की फोटो *",
    aadhaarBack: "आधार पीछे की फोटो *",
    aadhaarPhotosReq: "आधार के आगे-पीछे की फोटो अनिवार्य हैं",
    aadhaarAdminOnly: "केवल VHRP एडमिन को दिखेगा",
    tabHome: "होम",
    tabMembership: "सदस्यता",
    tabGrievance: "शिकायत",
    tabProfile: "प्रोफ़ाइल",
    langTitle: "अपनी भाषा चुनें",
    langSubtitle: "वह भाषा चुनें जिसमें आप सबसे सहज हैं",
    langContinue: "जारी रखें",
    loginTagline: "सदस्यता • शिकायत • सेवा",
    loginGoogle: "Google से जारी रखें",
    loginLegal: "जारी रखकर आप VHRP की शर्तों\nऔर गोपनीयता नीति से सहमत हैं।",
    greet: "नमस्ते 🙏",
    defaultMember: "सदस्य",
    heroTitle: "समाज की रक्षा, सशक्तिकरण और प्रगति",
    heroSub: "राम नवमी के शुभ अवसर पर श्री गोपाल राय द्वारा स्थापित",
    heroCta: "सदस्य बनें",
    quickGrievance: "शिकायत",
    quickPlans: "सदस्यता",
    quickAbout: "परिचय",
    quickContact: "संपर्क",
    unlockTitle: "सदस्यता प्राप्त करें",
    unlockTitlePending: "सदस्यता पूरी करें",
    unlockSub: "VHRP से जुड़ें और तुरंत अपना आधिकारिक डिजिटल पहचान पत्र पाएं।",
    unlockSubPending: "बस थोड़ा और — भुगतान पूरा करें और डिजिटल पहचान पत्र पाएं।",
    founderMsgTitle: "संस्थापक का संदेश",
    founderName: "श्री गोपाल राय",
    founderRole: "अंतरराष्ट्रीय अध्यक्ष (वीएचआरपी)",
    founderQuote: "हमारा उद्देश्य हिन्दू समाज को सशक्त बनाना, संस्कृति की रक्षा करना और एकता की भावना को बढ़ावा देना है।",
    galleryTitle: "फोटो गैलरी",
    latestUpdates: "ताज़ा समाचार और कार्यक्रम",
    statPrograms: "जागरूकता कार्यक्रम",
    statRelief: "आपदा राहत सहायता",
    statCenters: "प्रशिक्षण केंद्र",
    aboutKicker: "हमारे बारे में",
    aboutTitle: "विश्व हिन्दू\nरक्षा परिषद",
    aboutHeroSub: "समाज की रक्षा, सशक्तिकरण और प्रगति के लिए समर्पित एक धार्मिक और सामाजिक संगठन।",
    aboutStoryTitle: "हमारी कहानी",
    aboutStory: "विश्व हिन्दू रक्षा परिषद (VHRP) एक धार्मिक और सामाजिक संगठन है जिसकी स्थापना श्री गोपाल राय ने राम नवमी के शुभ अवसर पर की। देश भर की यात्राओं के दौरान श्री गोपाल राय ने अनुभव किया कि हिन्दू समाज का विकास अपेक्षित गति से नहीं हो रहा है। इस स्थिति को बदलने के लिए उन्होंने हिन्दू धर्म और समाज को अधिक सशक्त और संगठित रूप में प्रस्तुत करने हेतु VHRP की स्थापना की।",
    objectivesTitle: "हमारे मुख्य उद्देश्य",
    obj1: "भारत को हिन्दू राष्ट्र बनाना",
    obj2: "जातिवाद को समाप्त करना",
    obj3: "बाल विवाह पर रोक",
    obj4: "गरीब बच्चों को शिक्षा देना",
    obj5: "गौ-हत्या पर प्रतिबंध",
    obj6: "आर्थिक रूप से कमजोर परिवारों की बेटियों के विवाह में सहयोग",
    purposeTitle: "हमारा उद्देश्य",
    purposeBody: "VHRP हिन्दू धर्म की विरासत, संस्कृति और मूल्यों की रक्षा करता है, परंपराओं का संरक्षण करता है, और सामाजिक समस्याओं का समाधान कर एक सशक्त समाज का निर्माण करता है।",
    coreValuesTitle: "हमारे मूल मूल्य",
    coreValuesBody: "हम सेवा और संस्कृति के माध्यम से समाज की एकता को मजबूत करते हैं। सत्य, करुणा और सहिष्णुता के साथ विविधता को अपनाते हुए शांतिपूर्ण सह-अस्तित्व में विश्वास रखते हैं।",
    initiativesTitle: "प्रभावशाली पहल",
    initiativesBody: "\"संस्कृति रक्षा योजना\" परंपराओं का संरक्षण करती है, \"बाल विकास केंद्र\" युवाओं को सशक्त बनाता है, \"सेवा केंद्र\" स्वास्थ्य सेवाएँ देता है, और \"ग्लोबल हिन्दू अभियान\" एकता बढ़ाता है।",
    achievementsTitle: "हमारी उपलब्धियाँ",
    achievementsBody: "500+ जागरूकता कार्यक्रम, 50,000+ लोगों को आपदा राहत, युवाओं के लिए प्रशिक्षण केंद्र, और प्राचीन मंदिरों व परंपराओं के संरक्षण के अभियान।",
    founderSecTitle: "हमारे संस्थापक",
    founderDesc: "VHRP के अंतरराष्ट्रीय अध्यक्ष श्री गोपाल राय अपनी नेतृत्व क्षमता और समाज के प्रति समर्पण के लिए प्रसिद्ध हैं। उनका उद्देश्य समाज को सशक्त बनाना, संस्कृति की रक्षा करना और एकता को बढ़ावा देना है।",
    joinCta: "VHRP से जुड़ें",
    contactTitle: "संपर्क करें",
    contactIntro: "कोई प्रश्न है? सहायता, सदस्यता या साझेदारी के लिए VHRP से संपर्क करें।",
    contactCallLabel: "फ़ोन (कार्यालय)",
    contactMobileLabel: "मोबाइल / हेल्पलाइन",
    contactEmailLabel: "ईमेल",
    contactWebsiteLabel: "वेबसाइट",
    contactAddressLabel: "मुख्य कार्यालय",
    memTitle: "सदस्यता चुनें",
    memSubtitle: "VHRP के मिशन का समर्थन करें। अपने अनुकूल श्रेणी चुनें।",
    perYear: "/ वर्ष",
    memContinue: "पंजीकरण जारी रखें",
    memUpgrade: "अपग्रेड / नवीनीकरण",
    tierSupporter: "समर्थक",
    tierFriend: "मित्र",
    tierAssociate: "सहयोगी",
    tierActive: "सक्रिय सदस्य",
    tierPatron: "संरक्षक",
    tierFounder: "संस्थापक मंडल",
    ben1: "डिजिटल सदस्यता पहचान पत्र",
    ben2: "1 वर्ष की वैधता",
    ben3: "न्यूज़लेटर अपडेट",
    ben4: "कार्यक्रम निमंत्रण",
    ben5: "स्वयंसेवा के अवसर",
    ben6: "मित्र श्रेणी की सभी सुविधाएँ",
    ben7: "शिकायत पर प्राथमिकता से कार्रवाई",
    ben8: "स्थानीय शाखा तक पहुँच",
    ben9: "सहयोगी श्रेणी की सभी सुविधाएँ",
    ben10: "राज्य-स्तरीय कार्यक्रम",
    ben11: "सम्मान प्रमाण पत्र",
    ben12: "सक्रिय श्रेणी की सभी सुविधाएँ",
    ben13: "राष्ट्रीय सम्मेलन में प्रवेश",
    ben14: "नेतृत्व से सीधा संपर्क",
    ben15: "संरक्षक श्रेणी की सभी सुविधाएँ",
    ben16: "आजीवन सम्मान",
    ben17: "विशेष संस्थापक कार्यक्रम",
    ben18: "नेतृत्व द्वारा व्यक्तिगत स्वागत",
    grvTitle: "शिकायत दर्ज करें",
    grvSubtitle: "VHRP को कोई समस्या या शिकायत बताएं।",
    grvSubject: "विषय *",
    grvSubjectPh: "संक्षिप्त शीर्षक",
    grvCategory: "श्रेणी",
    grvLocation: "स्थान (शहर, राज्य)",
    grvLocationPh: "जैसे लखनऊ, उत्तर प्रदेश",
    grvDesc: "समस्या का विवरण दें *",
    grvDescPh: "कृपया पूरी जानकारी दें — क्या हुआ, कब हुआ और कौन शामिल था।",
    grvSubmit: "शिकायत भेजें",
    grvFillReq: "कृपया विषय और विवरण भरें",
    grvOkTitle: "शिकायत प्राप्त हुई",
    grvOkSub: "आपकी शिकायत दर्ज हो गई है। हमारी टीम 3 कार्य दिवसों में संपर्क करेगी।",
    grvTicket: "टिकट आईडी",
    grvAnother: "एक और शिकायत दर्ज करें",
    catLand: "भूमि विवाद",
    catCorruption: "भ्रष्टाचार",
    catPublic: "सार्वजनिक सेवा",
    catWomen: "महिला सुरक्षा",
    catCommunal: "सांप्रदायिक मुद्दा",
    catOther: "अन्य",
    regTitle: "सदस्यता विवरण",
    regTierLabel: "श्रेणी",
    regPhotoAdd: "फोटो जोड़ें",
    regPhotoHint: "पासपोर्ट फोटो (3:4)\nआपके डिजिटल पहचान पत्र पर उपयोग होगी।",
    regFullName: "पूरा नाम *",
    regFather: "पिता / अभिभावक का नाम *",
    regAddress: "पता *",
    regPhone: "फ़ोन *",
    regDob: "जन्म तिथि *",
    regEmail: "ईमेल",
    regDesignation: "पद",
    regBlood: "रक्त समूह",
    regAadhaar: "आधार नंबर *",
    regPay: "भुगतान करें",
    regFillReq: "कृपया सभी आवश्यक फ़ील्ड भरें",
    regPhotoPerm: "फोटो की अनुमति आवश्यक है",
    regDefaultDesig: "सामान्य सदस्य",
    payTitle: "भुगतान",
    payCreating: "आपका ऑर्डर बनाया जा रहा है…",
    payAmount: "देय राशि",
    payDemo: "डेमो मोड: Razorpay कुंजियाँ कॉन्फ़िगर नहीं हैं। \"भुगतान\" दबाने पर प्रोटोटाइप के लिए सफल भुगतान सिमुलेट होगा।",
    paySimulate: "भुगतान सिमुलेट करें",
    payNow: "अभी भुगतान करें",
    paySecured: "🔒 Razorpay द्वारा सुरक्षित",
    payNonRefundable: "आगे बढ़ने पर, आप सहमत हैं कि सदस्यता राशि वापस नहीं की जाएगी।",
    payProcessing: "भुगतान प्रक्रिया में…",
    payFailTitle: "भुगतान विफल",
    payFailSub: "कुछ गड़बड़ हो गई। पुनः प्रयास करें।",
    payBack: "वापस जाएँ",
    payOkTitle: "आप सदस्य बन गए! 🎉",
    payOkSub: "भुगतान प्राप्त हुआ। आपका डिजिटल पहचान पत्र तैयार है।",
    payViewCard: "मेरा डिजिटल कार्ड देखें",
    cardHeadTitle: "मेरा डिजिटल पहचान पत्र",
    cardScan: "सत्यापन हेतु स्कैन करें",
    cardScanHint: "सत्यापनकर्ता इस कोड को स्कैन कर आपकी सक्रिय सदस्यता की पुष्टि कर सकते हैं।",
    cardEmptyTitle: "कोई सक्रिय सदस्यता नहीं",
    cardEmptySub: "डिजिटल पहचान पत्र पाने के लिए पंजीकरण पूरा करें।",
    cardGet: "सदस्यता लें",
    dMembershipId: "सदस्यता आईडी",
    dTier: "श्रेणी",
    dFullName: "पूरा नाम",
    dFather: "पिता का नाम",
    dDob: "जन्म तिथि",
    dPhone: "फ़ोन",
    dAddress: "पता",
    cardShareMsg: "मैं अब विश्व हिन्दू रक्षा परिषद का सदस्य हूँ! सदस्यता आईडी:",
    cardOfficialSub: "डिजिटल सदस्यता पत्र",
    cardValidUntil: "वैधता",
    cardSo: "पिता",
    cardBlood: "रक्त",
    cardCity: "शहर",
    cardState: "राज्य",
    profCardSection: "मेरा डिजिटल कार्ड",
    profBecome: "सदस्य बनें",
    profBecomeSub: "मिनटों में अपना आधिकारिक डिजिटल पहचान पत्र पाएं।",
    profComplaints: "मेरी शिकायतें",
    profMore: "अधिक",
    profAboutItem: "VHRP के बारे में",
    profContactItem: "संपर्क करें",
    profPrivacy: "गोपनीयता नीति",
    profDelete: "खाता हटाएं",
    profDeleteWarn: "इससे आपका खाता, सदस्यता, डिजिटल आईडी कार्ड, आधार विवरण और शिकायतें स्थायी रूप से हट जाएंगी। भुगतान रिकॉर्ड कानूनी लेखांकन हेतु सुरक्षित रहते हैं। इसे पूर्ववत नहीं किया जा सकता।",
    profDeleteBtn: "स्थायी रूप से हटाएं",
    profDeleteCancel: "रद्द करें",
    profLanguageItem: "भाषा / Language",
    profLogout: "लॉग आउट",
    newsHeader: "समाचार",
    verifyTile: "सदस्य सत्यापित करें",
    verifyTitle: "सदस्य सत्यापन",
    verifyIntro: "सदस्य का QR कोड स्कैन कर तुरंत उनकी सदस्यता की पुष्टि करें। कैमरे का उपयोग केवल स्कैनिंग के लिए होता है।",
    verifyEnable: "कैमरा चालू करें और स्कैन करें",
    verifyDeniedMsg: "कैमरे की अनुमति नहीं मिली। नीचे सदस्यता आईडी टाइप करें, या सेटिंग्स में कैमरा चालू करें।",
    verifyOpenSettings: "सेटिंग्स खोलें",
    verifyScanHint: "कैमरे को सदस्य के QR कोड पर रखें",
    verifyManual: "या सदस्यता आईडी दर्ज करें",
    verifyCheck: "सत्यापित करें",
    verifyChecking: "सत्यापन हो रहा है…",
    verifyValid: "वैध सदस्य",
    verifyExpired: "सदस्यता समाप्त",
    verifyInvalid: "अमान्य सदस्य",
    verifyDeactivated: "सदस्यता निष्क्रिय",
    verifyNotFound: "इस आईडी से कोई सदस्य नहीं मिला।",
    verifyScanAgain: "दूसरा सत्यापित करें",
    verifyWebHint: "कैमरा स्कैनिंग मोबाइल ऐप में काम करती है। नीचे सदस्यता आईडी दर्ज करें।",
    cardSave: "इमेज सेव करें",
    cardShare: "शेयर करें",
    cardSaved: "कार्ड की इमेज गैलरी में सेव हो गई",
    cardSaveFailed: "कार्ड सेव नहीं हो सका",
    cardPermPhotos: "कार्ड को गैलरी में सेव करने के लिए फोटो की अनुमति दें",
    trackTitle: "शिकायत की स्थिति",
    stReceived: "प्राप्त हुई",
    stInReview: "समीक्षा में",
    stResolved: "समाधान हुआ",
    trackDesc: "विवरण",
    trackLocation: "स्थान",
    eventsTitle: "आगामी कार्यक्रम",
    eventsEmpty: "अभी कोई आगामी कार्यक्रम नहीं है। जल्द ही देखें!",
    rsvpGo: "मैं आऊंगा/आऊंगी",
    rsvpGoing: "आप जा रहे हैं ✓",
    attending: "उपस्थित होंगे",
    seeAll: "सभी देखें",
    renewSoonTitle: "सदस्यता जल्द समाप्त हो रही है",
    renewSoonBody: "आपकी सदस्यता {days} दिनों में समाप्त हो रही है। डिजिटल पहचान पत्र सक्रिय रखने के लिए नवीनीकरण करें।",
    renewExpiredTitle: "सदस्यता समाप्त हो गई",
    renewExpiredBody: "आपकी सदस्यता समाप्त हो गई है। डिजिटल पहचान पत्र पुनः सक्रिय करने के लिए अभी नवीनीकरण करें।",
    renewCta: "अभी नवीनीकरण करें",
    evToday: "आज है!",
    evTomorrow: "कल है!",
    regCity: "शहर *",
    regState: "राज्य *",
    regCountry: "देश",
    regAssembly: "विधान सभा क्षेत्र *",
    regAssemblyPh: "अपना विधानसभा क्षेत्र खोजें",
    regAssemblyReq: "कृपया अपना विधान सभा क्षेत्र चुनें",
    regSocial: "सोशल मीडिया लिंक",
    regSocialPh: "जैसे https://facebook.com/yourprofile",
    regAadhaarInvalid: "मान्य 12-अंकों का आधार नंबर दर्ज करें",
    otpSend: "OTP भेजें",
    otpSent: "आपके नंबर पर OTP भेजा गया",
    otpEnterPh: "6-अंकों का OTP",
    otpVerify: "सत्यापित करें",
    otpVerified: "सत्यापित ✓",
    otpDemoNote: "डेमो मोड — आपका OTP है:",
    otpRequired: "कृपया पहले OTP से फ़ोन नंबर सत्यापित करें",
    dirTile: "सदस्य निर्देशिका",
    dirTotalLabel: "पंजीकृत सदस्य",
    dirSearchPh: "नाम, शहर या राज्य खोजें…",
    dirAll: "सभी",
    dirIndia: "भारत",
    dirIntl: "अंतर्राष्ट्रीय",
    dirCityAll: "सभी शहर",
    dirMoreCities: "और शहर",
    dirPickCity: "शहर चुनें",
    dirCitySearchPh: "शहर खोजें…",
    dirOtherRegion: "अन्य",
    dirLockedTitle: "केवल सदस्यों के लिए",
    dirLockedSub: "सदस्य निर्देशिका केवल सक्रिय सदस्यों के लिए उपलब्ध है। भारत और विदेश के VHRP सदस्यों से जुड़ने के लिए सदस्यता लें।",
    dirEmpty: "कोई सदस्य नहीं मिला",
    grvPhotos: "प्रमाण के रूप में फोटो संलग्न करें (वैकल्पिक, अधिकतम 3)",
    trackPhotos: "संलग्न फोटो",
  },
  ta: {
    orgName: "விஷ்வ ஹிந்து ரக்ஷா பரிஷத்",
    motto: "யதோ தர்ம: ததோ ஜய:",
    back: "பின்செல்",
    loadError: "தரவை ஏற்ற முடியவில்லை. உங்கள் இணைப்பைச் சரிபார்க்கவும்.",
    retry: "மீண்டும் முயற்சிக்கவும்",
    newBadge: "புதியது",
    videosTitle: "வீடியோக்கள்",
    videosEmpty: "இன்னும் வீடியோக்கள் இல்லை — எங்கள் YouTube சேனலைப் பாருங்கள்",
    desigMember: "உறுப்பினர்",
    desigGeneral: "பொது உறுப்பினர்",
    contactHQ: "மற்ற பொறுப்பு உறுப்பினர்களுக்கு தலைமை அலுவலகத்தைத் தொடர்பு கொள்ளவும்",
    promoTill: "4 அக்டோபர் வரை மட்டும்",
    inviteCopied: "அழைப்பு நகலெடுக்கப்பட்டது — WhatsApp-இல் ஒட்டவும்",
    share: "பகிர்",
    copied: "நகலெடுக்கப்பட்டது",
    photoVerifying: "AI உங்கள் புகைப்படத்தை சரிபார்க்கிறது…",
    photoRejected: "புகைப்படம் நிராகரிக்கப்பட்டது",
    aadhaarFront: "ஆதார் முன்புற புகைப்படம் *",
    aadhaarBack: "ஆதார் பின்புற புகைப்படம் *",
    aadhaarPhotosReq: "ஆதார் முன் & பின் புகைப்படங்கள் அவசியம்",
    aadhaarAdminOnly: "VHRP நிர்வாகிகளுக்கு மட்டும் தெரியும்",
    tabHome: "முகப்பு",
    tabMembership: "உறுப்பினர்",
    tabGrievance: "புகார்",
    tabProfile: "சுயவிவரம்",
    langTitle: "உங்கள் மொழியைத் தேர்ந்தெடுக்கவும்",
    langSubtitle: "உங்களுக்கு வசதியான மொழியைத் தேர்ந்தெடுக்கவும்",
    langContinue: "தொடரவும்",
    loginTagline: "உறுப்பினர் • புகார் • சேவை",
    loginGoogle: "Google மூலம் தொடரவும்",
    loginLegal: "தொடர்வதன் மூலம் VHRP இன் விதிமுறைகள்\nமற்றும் தனியுரிமைக் கொள்கையை ஏற்கிறீர்கள்.",
    greet: "வணக்கம் 🙏",
    defaultMember: "உறுப்பினர்",
    heroTitle: "சமூகத்தின் பாதுகாப்பு, மேம்பாடு மற்றும் முன்னேற்றம்",
    heroSub: "ராம நவமி நன்னாளில் ஸ்ரீ கோபால் ராய் அவர்களால் நிறுவப்பட்டது",
    heroCta: "உறுப்பினராகுங்கள்",
    quickGrievance: "புகார்",
    quickPlans: "உறுப்பினர்",
    quickAbout: "எங்களைப் பற்றி",
    quickContact: "தொடர்பு",
    unlockTitle: "உறுப்பினராகுங்கள்",
    unlockTitlePending: "உறுப்பினர் பதிவை முடிக்கவும்",
    unlockSub: "VHRP இல் இணைந்து உடனடியாக அதிகாரப்பூர்வ டிஜிட்டல் அடையாள அட்டையைப் பெறுங்கள்.",
    unlockSubPending: "கிட்டத்தட்ட முடிந்தது — பணம் செலுத்தி டிஜிட்டல் அடையாள அட்டையைப் பெறுங்கள்.",
    founderMsgTitle: "நிறுவனர் செய்தி",
    founderName: "ஸ்ரீ கோபால் ராய்",
    founderRole: "சர்வதேசத் தலைவர் (VHRP)",
    founderQuote: "சமூகத்தை வலுப்படுத்துவதும், நமது கலாச்சாரத்தைப் பாதுகாப்பதும், ஒற்றுமை உணர்வை வளர்ப்பதும் எங்கள் நோக்கம்.",
    galleryTitle: "புகைப்படத் தொகுப்பு",
    latestUpdates: "சமீபத்திய செய்திகள் & நிகழ்வுகள்",
    statPrograms: "விழிப்புணர்வு நிகழ்ச்சிகள்",
    statRelief: "பேரிடர் நிவாரணம்",
    statCenters: "பயிற்சி மையங்கள்",
    aboutKicker: "எங்களைப் பற்றி",
    aboutTitle: "விஷ்வ ஹிந்து\nரக்ஷா பரிஷத்",
    aboutHeroSub: "சமூகத்தின் பாதுகாப்பு, மேம்பாடு மற்றும் முன்னேற்றத்திற்காக அர்ப்பணிக்கப்பட்ட மத மற்றும் சமூக அமைப்பு.",
    aboutStoryTitle: "எங்கள் கதை",
    aboutStory: "விஷ்வ ஹிந்து ரக்ஷா பரிஷத் (VHRP) என்பது ராம நவமி நன்னாளில் ஸ்ரீ கோபால் ராய் அவர்களால் நிறுவப்பட்ட மத மற்றும் சமூக அமைப்பாகும். நாடு முழுவதும் பயணித்தபோது, இந்து சமூகத்தின் வளர்ச்சி எதிர்பார்த்தபடி இல்லை என்பதை அவர் உணர்ந்தார். இந்நிலையை மாற்ற, இந்து மதத்தையும் சமூகத்தையும் வலுவாகவும் ஒழுங்கமைக்கப்பட்டதாகவும் முன்னிறுத்த VHRP ஐ நிறுவினார்.",
    objectivesTitle: "எங்கள் முக்கிய நோக்கங்கள்",
    obj1: "இந்தியாவை இந்து தேசமாக்குதல்",
    obj2: "சாதிவெறியை ஒழித்தல்",
    obj3: "குழந்தை திருமணத்தைத் தடுத்தல்",
    obj4: "ஏழைக் குழந்தைகளுக்குக் கல்வி",
    obj5: "பசு வதைக் கூடங்களைத் தடை செய்தல்",
    obj6: "பொருளாதாரத்தில் நலிந்த குடும்பப் பெண்களின் திருமணத்திற்கு உதவுதல்",
    purposeTitle: "எங்கள் நோக்கம்",
    purposeBody: "VHRP இந்து மதத்தின் பாரம்பரியம், கலாச்சாரம் மற்றும் விழுமியங்களைப் பாதுகாத்து, சமூகப் பிரச்சினைகளைத் தீர்த்து வலுவான சமூகத்தை உருவாக்குகிறது.",
    coreValuesTitle: "எங்கள் அடிப்படை விழுமியங்கள்",
    coreValuesBody: "சேவை மற்றும் கலாச்சாரத்தின் மூலம் சமூக ஒற்றுமையை வலுப்படுத்துகிறோம். உண்மை, கருணை, சகிப்புத்தன்மையுடன் அமைதியான சகவாழ்வில் நம்பிக்கை கொண்டுள்ளோம்.",
    initiativesTitle: "தாக்கம் மிக்க முயற்சிகள்",
    initiativesBody: "\"சம்ஸ்கிருதி ரக்ஷா யோஜனா\" பாரம்பரியங்களைப் பாதுகாக்கிறது, \"குழந்தை மேம்பாட்டு மையம்\" இளைஞர்களை வலுப்படுத்துகிறது, \"சேவா கேந்திரம்\" சுகாதார சேவைகளை வழங்குகிறது.",
    achievementsTitle: "எங்கள் சாதனைகள்",
    achievementsBody: "500+ விழிப்புணர்வு நிகழ்ச்சிகள், 50,000+ பேருக்கு பேரிடர் நிவாரணம், இளைஞர்களுக்கான பயிற்சி மையங்கள், பழமையான கோயில்களைப் பாதுகாக்கும் இயக்கங்கள்.",
    founderSecTitle: "எங்கள் நிறுவனர்",
    founderDesc: "VHRP இன் சர்வதேசத் தலைவர் ஸ்ரீ கோபால் ராய், தலைமைத்துவம் மற்றும் சமூக அர்ப்பணிப்பிற்காக அறியப்படுகிறார். சமூகத்தை வலுப்படுத்துவதும் கலாச்சாரத்தைப் பாதுகாப்பதும் அவரது நோக்கம்.",
    joinCta: "VHRP இல் இணையுங்கள்",
    contactTitle: "தொடர்பு கொள்ளவும்",
    contactIntro: "கேள்விகள் உள்ளதா? ஆதரவு, உறுப்பினர் அல்லது கூட்டாண்மைக்கு VHRP ஐ அணுகவும்.",
    contactCallLabel: "தொலைபேசி (அலுவலகம்)",
    contactMobileLabel: "மொபைல் / உதவி எண்",
    contactEmailLabel: "மின்னஞ்சல்",
    contactWebsiteLabel: "இணையதளம்",
    contactAddressLabel: "தலைமை அலுவலகம்",
    memTitle: "உறுப்பினர் வகையைத் தேர்வு செய்யவும்",
    memSubtitle: "VHRP இன் பணிக்கு ஆதரவளியுங்கள். உங்களுக்கு ஏற்ற வகையைத் தேர்ந்தெடுங்கள்.",
    perYear: "/ ஆண்டு",
    memContinue: "பதிவைத் தொடரவும்",
    memUpgrade: "மேம்படுத்து / புதுப்பி",
    tierSupporter: "ஆதரவாளர்",
    tierFriend: "நண்பர்",
    tierAssociate: "இணை உறுப்பினர்",
    tierActive: "செயலூக்க உறுப்பினர்",
    tierPatron: "புரவலர்",
    tierFounder: "நிறுவனர் வட்டம்",
    ben1: "டிஜிட்டல் உறுப்பினர் அடையாள அட்டை",
    ben2: "1 ஆண்டு செல்லுபடி",
    ben3: "செய்திமடல் புதுப்பிப்புகள்",
    ben4: "நிகழ்வு அழைப்புகள்",
    ben5: "தன்னார்வ வாய்ப்புகள்",
    ben6: "நண்பர் வகையின் அனைத்தும்",
    ben7: "புகாருக்கு முன்னுரிமை பதில்",
    ben8: "உள்ளூர் கிளை அணுகல்",
    ben9: "இணை உறுப்பினர் வகையின் அனைத்தும்",
    ben10: "மாநில அளவிலான நிகழ்வுகள்",
    ben11: "அங்கீகார சான்றிதழ்",
    ben12: "செயலூக்க வகையின் அனைத்தும்",
    ben13: "தேசிய மாநாட்டு அனுமதி",
    ben14: "தலைமையுடன் நேரடித் தொடர்பு",
    ben15: "புரவலர் வகையின் அனைத்தும்",
    ben16: "வாழ்நாள் அங்கீகாரம்",
    ben17: "சிறப்பு நிறுவனர் நிகழ்வுகள்",
    ben18: "தலைமையின் தனிப்பட்ட வரவேற்பு",
    grvTitle: "புகார் அளிக்கவும்",
    grvSubtitle: "VHRP இடம் பிரச்சினை அல்லது புகாரைத் தெரிவிக்கவும்.",
    grvSubject: "தலைப்பு *",
    grvSubjectPh: "சுருக்கமான தலைப்பு",
    grvCategory: "வகை",
    grvLocation: "இடம் (நகரம், மாநிலம்)",
    grvLocationPh: "உதா. சென்னை, தமிழ்நாடு",
    grvDesc: "பிரச்சினையை விவரிக்கவும் *",
    grvDescPh: "முழு விவரங்களைப் பகிரவும் — என்ன நடந்தது, எப்போது, யார் சம்பந்தப்பட்டவர்கள்.",
    grvSubmit: "புகாரைச் சமர்ப்பிக்கவும்",
    grvFillReq: "தலைப்பு மற்றும் விவரத்தை நிரப்பவும்",
    grvOkTitle: "புகார் பெறப்பட்டது",
    grvOkSub: "உங்கள் புகார் பதிவு செய்யப்பட்டது. எங்கள் குழு 3 வேலை நாட்களில் தொடர்பு கொள்ளும்.",
    grvTicket: "டிக்கெட் ஐடி",
    grvAnother: "மற்றொரு புகார் அளிக்கவும்",
    catLand: "நிலத் தகராறு",
    catCorruption: "ஊழல்",
    catPublic: "பொது சேவை",
    catWomen: "பெண்கள் பாதுகாப்பு",
    catCommunal: "வகுப்புவாத பிரச்சினை",
    catOther: "மற்றவை",
    regTitle: "உறுப்பினர் விவரங்கள்",
    regTierLabel: "வகை",
    regPhotoAdd: "புகைப்படம் சேர்க்கவும்",
    regPhotoHint: "பாஸ்போர்ட் புகைப்படம் (3:4)\nஉங்கள் டிஜிட்டல் அடையாள அட்டையில் பயன்படும்.",
    regFullName: "முழுப் பெயர் *",
    regFather: "தந்தை / பாதுகாவலர் பெயர் *",
    regAddress: "முகவரி *",
    regPhone: "தொலைபேசி *",
    regDob: "பிறந்த தேதி *",
    regEmail: "மின்னஞ்சல்",
    regDesignation: "பதவி",
    regBlood: "இரத்தப் பிரிவு",
    regAadhaar: "ஆதார் எண் *",
    regPay: "பணம் செலுத்த தொடரவும்",
    regFillReq: "தேவையான அனைத்து புலங்களையும் நிரப்பவும்",
    regPhotoPerm: "புகைப்பட அனுமதி தேவை",
    regDefaultDesig: "பொது உறுப்பினர்",
    payTitle: "கட்டணம்",
    payCreating: "உங்கள் ஆர்டர் உருவாக்கப்படுகிறது…",
    payAmount: "செலுத்த வேண்டிய தொகை",
    payDemo: "டெமோ முறை: Razorpay விசைகள் அமைக்கப்படவில்லை. \"பணம் செலுத்து\" அழுத்தினால் மாதிரி வெற்றிகரமான கட்டணம் உருவகப்படுத்தப்படும்.",
    paySimulate: "கட்டணத்தை உருவகப்படுத்து",
    payNow: "இப்போது செலுத்தவும்",
    paySecured: "🔒 Razorpay மூலம் பாதுகாக்கப்பட்டது",
    payProcessing: "கட்டணம் செயலாக்கப்படுகிறது…",
    payFailTitle: "கட்டணம் தோல்வி",
    payFailSub: "ஏதோ தவறு நடந்தது. மீண்டும் முயற்சிக்கவும்.",
    payBack: "பின் செல்லவும்",
    payOkTitle: "நீங்கள் உறுப்பினர் ஆனீர்கள்! 🎉",
    payOkSub: "கட்டணம் பெறப்பட்டது. உங்கள் டிஜிட்டல் அடையாள அட்டை தயார்.",
    payViewCard: "என் டிஜிட்டல் அட்டையைக் காண்க",
    cardHeadTitle: "என் டிஜிட்டல் அடையாளம்",
    cardScan: "சரிபார்க்க ஸ்கேன் செய்யவும்",
    cardScanHint: "சரிபார்ப்பாளர்கள் இந்தக் குறியீட்டை ஸ்கேன் செய்து உங்கள் உறுப்பினர் நிலையை உறுதிப்படுத்தலாம்.",
    cardEmptyTitle: "செயலில் உள்ள உறுப்பினர் இல்லை",
    cardEmptySub: "டிஜிட்டல் அடையாள அட்டை பெற பதிவை முடிக்கவும்.",
    cardGet: "உறுப்பினராகவும்",
    dMembershipId: "உறுப்பினர் ஐடி",
    dTier: "வகை",
    dFullName: "முழுப் பெயர்",
    dFather: "தந்தை பெயர்",
    dDob: "பிறந்த தேதி",
    dPhone: "தொலைபேசி",
    dAddress: "முகவரி",
    cardShareMsg: "நான் இப்போது விஷ்வ ஹிந்து ரக்ஷா பரிஷத்தின் உறுப்பினர்! உறுப்பினர் ஐடி:",
    cardOfficialSub: "டிஜிட்டல் உறுப்பினர் அட்டை",
    cardValidUntil: "செல்லுபடி",
    cardSo: "தந்தை",
    cardBlood: "இரத்தம்",
    cardCity: "நகரம்",
    cardState: "மாநிலம்",
    profCardSection: "என் டிஜிட்டல் அட்டை",
    profBecome: "உறுப்பினராகுங்கள்",
    profBecomeSub: "நிமிடங்களில் அதிகாரப்பூர்வ டிஜிட்டல் அடையாள அட்டையைப் பெறுங்கள்.",
    profComplaints: "என் புகார்கள்",
    profMore: "மேலும்",
    profAboutItem: "VHRP பற்றி",
    profContactItem: "தொடர்பு கொள்ள",
    profPrivacy: "தனியுரிமைக் கொள்கை",
    profLanguageItem: "மொழி / Language",
    profLogout: "வெளியேறு",
    newsHeader: "செய்தி",
    verifyTile: "உறுப்பினரைச் சரிபார்க்கவும்",
    verifyTitle: "உறுப்பினர் சரிபார்ப்பு",
    verifyIntro: "உறுப்பினரின் QR குறியீட்டை ஸ்கேன் செய்து உடனடியாக உறுப்பினர் நிலையை உறுதிப்படுத்துங்கள். கேமரா ஸ்கேனிங்கிற்கு மட்டுமே பயன்படும்.",
    verifyEnable: "கேமராவை இயக்கி ஸ்கேன் செய்யவும்",
    verifyDeniedMsg: "கேமரா அனுமதி மறுக்கப்பட்டது. கீழே உறுப்பினர் ஐடியை உள்ளிடவும், அல்லது அமைப்புகளில் கேமராவை இயக்கவும்.",
    verifyOpenSettings: "அமைப்புகளைத் திறக்கவும்",
    verifyScanHint: "கேமராவை உறுப்பினரின் QR குறியீட்டில் காட்டவும்",
    verifyManual: "அல்லது உறுப்பினர் ஐடியை உள்ளிடவும்",
    verifyCheck: "சரிபார்க்கவும்",
    verifyChecking: "சரிபார்க்கப்படுகிறது…",
    verifyValid: "செல்லுபடியான உறுப்பினர்",
    verifyExpired: "உறுப்பினர் காலாவதி",
    verifyInvalid: "செல்லாத உறுப்பினர்",
    verifyNotFound: "இந்த ஐடியில் உறுப்பினர் இல்லை.",
    verifyScanAgain: "மற்றொன்றை சரிபார்க்கவும்",
    verifyWebHint: "கேமரா ஸ்கேனிங் மொபைல் ஆப்பில் செயல்படும். கீழே உறுப்பினர் ஐடியை உள்ளிடவும்.",
    cardSave: "படத்தைச் சேமிக்கவும்",
    cardShare: "பகிரவும்",
    cardSaved: "அட்டைப் படம் கேலரியில் சேமிக்கப்பட்டது",
    cardSaveFailed: "அட்டையைச் சேமிக்க முடியவில்லை",
    cardPermPhotos: "அட்டையை கேலரியில் சேமிக்க புகைப்பட அனுமதி வழங்கவும்",
    trackTitle: "புகார் நிலை",
    stReceived: "பெறப்பட்டது",
    stInReview: "பரிசீலனையில்",
    stResolved: "தீர்க்கப்பட்டது",
    trackDesc: "விவரம்",
    trackLocation: "இடம்",
    eventsTitle: "வரவிருக்கும் நிகழ்வுகள்",
    eventsEmpty: "தற்போது வரவிருக்கும் நிகழ்வுகள் இல்லை. விரைவில் பாருங்கள்!",
    rsvpGo: "நான் கலந்துகொள்வேன்",
    rsvpGoing: "நீங்கள் செல்கிறீர்கள் ✓",
    attending: "கலந்துகொள்கிறார்கள்",
    seeAll: "அனைத்தையும் காண்க",
    renewSoonTitle: "உறுப்பினர் காலம் விரைவில் முடிகிறது",
    renewSoonBody: "உங்கள் உறுப்பினர் காலம் {days} நாட்களில் முடிகிறது. டிஜிட்டல் அடையாள அட்டையை செயலில் வைக்க புதுப்பிக்கவும்.",
    renewExpiredTitle: "உறுப்பினர் காலம் முடிந்தது",
    renewExpiredBody: "உங்கள் உறுப்பினர் காலம் முடிந்துவிட்டது. மீண்டும் செயல்படுத்த இப்போதே புதுப்பிக்கவும்.",
    renewCta: "இப்போது புதுப்பிக்கவும்",
    evToday: "இன்று!",
    evTomorrow: "நாளை!",
    regCity: "நகரம் *",
    regState: "மாநிலம் *",
    regCountry: "நாடு",
    regSocial: "சமூக ஊடக இணைப்பு",
    regSocialPh: "உதா. https://facebook.com/yourprofile",
    regAadhaarInvalid: "சரியான 12-இலக்க ஆதார் எண்ணை உள்ளிடவும்",
    otpSend: "OTP அனுப்பவும்",
    otpSent: "உங்கள் எண்ணுக்கு OTP அனுப்பப்பட்டது",
    otpEnterPh: "6-இலக்க OTP",
    otpVerify: "சரிபார்க்கவும்",
    otpVerified: "சரிபார்க்கப்பட்டது ✓",
    otpDemoNote: "டெமோ முறை — உங்கள் OTP:",
    otpRequired: "முதலில் OTP மூலம் தொலைபேசி எண்ணைச் சரிபார்க்கவும்",
    dirTile: "உறுப்பினர் அடைவு",
    dirTotalLabel: "பதிவு செய்த உறுப்பினர்கள்",
    dirSearchPh: "பெயர், நகரம் அல்லது மாநிலம் தேடவும்…",
    dirAll: "அனைத்தும்",
    dirIndia: "இந்தியா",
    dirIntl: "சர்வதேசம்",
    dirLockedTitle: "உறுப்பினர்களுக்கு மட்டும்",
    dirLockedSub: "உறுப்பினர் அடைவு செயலில் உள்ள உறுப்பினர்களுக்கு மட்டுமே. இந்தியா மற்றும் வெளிநாடுகளில் உள்ள VHRP உறுப்பினர்களுடன் இணைய உறுப்பினராகுங்கள்.",
    dirEmpty: "உறுப்பினர்கள் இல்லை",
    grvPhotos: "ஆதாரமாக புகைப்படங்களை இணைக்கவும் (விருப்பம், அதிகபட்சம் 3)",
    trackPhotos: "இணைக்கப்பட்ட புகைப்படங்கள்",
  },
  ml: {
    orgName: "വിശ്വ ഹിന്ദു രക്ഷാ പരിഷത്ത്",
    motto: "യതോ ധർമ്മഃ തതോ ജയഃ",
    back: "മടങ്ങുക",
    loadError: "ഡാറ്റ ലോഡ് ചെയ്യാനായില്ല. നിങ്ങളുടെ കണക്ഷൻ പരിശോധിക്കുക.",
    retry: "വീണ്ടും ശ്രമിക്കുക",
    newBadge: "പുതിയത്",
    videosTitle: "വീഡിയോകൾ",
    videosEmpty: "വീഡിയോകൾ ഇല്ല — ഞങ്ങളുടെ YouTube ചാനൽ കാണുക",
    desigMember: "അംഗം",
    desigGeneral: "പൊതു അംഗം",
    contactHQ: "മറ്റ് ഉത്തരവാദിത്ത അംഗത്വങ്ങൾക്ക് ഹെഡ് ഓഫീസുമായി ബന്ധപ്പെടുക",
    promoTill: "ഒക്ടോബർ 4 വരെ മാത്രം",
    inviteCopied: "ക്ഷണം പകർത്തി — WhatsApp-ൽ പേസ്റ്റ് ചെയ്യുക",
    share: "പങ്കിടുക",
    copied: "ക്ലിപ്ബോർഡിലേക്ക് പകർത്തി",
    photoVerifying: "AI നിങ്ങളുടെ ഫോട്ടോ പരിശോധിക്കുന്നു…",
    photoRejected: "ഫോട്ടോ നിരസിച്ചു",
    aadhaarFront: "ആധാർ മുൻവശം ഫോട്ടോ *",
    aadhaarBack: "ആധാർ പിൻവശം ഫോട്ടോ *",
    aadhaarPhotosReq: "ആധാർ മുൻ-പിൻ ഫോട്ടോകൾ നിർബന്ധമാണ്",
    aadhaarAdminOnly: "VHRP അഡ്മിനുകൾക്ക് മാത്രം കാണാം",
    tabHome: "ഹോം",
    tabMembership: "അംഗത്വം",
    tabGrievance: "പരാതി",
    tabProfile: "പ്രൊഫൈൽ",
    langTitle: "നിങ്ങളുടെ ഭാഷ തിരഞ്ഞെടുക്കുക",
    langSubtitle: "നിങ്ങൾക്ക് ഏറ്റവും സൗകര്യപ്രദമായ ഭാഷ തിരഞ്ഞെടുക്കുക",
    langContinue: "തുടരുക",
    loginTagline: "അംഗത്വം • പരാതി • സേവനം",
    loginGoogle: "Google ഉപയോഗിച്ച് തുടരുക",
    loginLegal: "തുടരുന്നതിലൂടെ VHRP യുടെ നിബന്ധനകളും\nസ്വകാര്യതാ നയവും അംഗീകരിക്കുന്നു.",
    greet: "നമസ്തേ 🙏",
    defaultMember: "അംഗം",
    heroTitle: "സമൂഹത്തിന്റെ സംരക്ഷണം, ശാക്തീകരണം, പുരോഗതി",
    heroSub: "രാമനവമി ശുഭദിനത്തിൽ ശ്രീ ഗോപാൽ റായ് സ്ഥാപിച്ചത്",
    heroCta: "അംഗമാകൂ",
    quickGrievance: "പരാതി",
    quickPlans: "അംഗത്വം",
    quickAbout: "ഞങ്ങളെക്കുറിച്ച്",
    quickContact: "ബന്ധപ്പെടുക",
    unlockTitle: "അംഗത്വം നേടുക",
    unlockTitlePending: "അംഗത്വം പൂർത്തിയാക്കുക",
    unlockSub: "VHRP യിൽ ചേർന്ന് ഔദ്യോഗിക ഡിജിറ്റൽ ഐഡി കാർഡ് ഉടനടി നേടുക.",
    unlockSubPending: "ഏകദേശം പൂർത്തിയായി — പണമടച്ച് ഡിജിറ്റൽ ഐഡി കാർഡ് നേടുക.",
    founderMsgTitle: "സ്ഥാപകന്റെ സന്ദേശം",
    founderName: "ശ്രീ ഗോപാൽ റായ്",
    founderRole: "അന്താരാഷ്ട്ര അധ്യക്ഷൻ (VHRP)",
    founderQuote: "സമൂഹത്തെ ശക്തിപ്പെടുത്തുക, നമ്മുടെ സംസ്കാരം സംരക്ഷിക്കുക, ഐക്യബോധം വളർത്തുക എന്നതാണ് ഞങ്ങളുടെ ലക്ഷ്യം.",
    galleryTitle: "ഫോട്ടോ ഗാലറി",
    latestUpdates: "ഏറ്റവും പുതിയ വാർത്തകളും പരിപാടികളും",
    statPrograms: "ബോധവൽക്കരണ പരിപാടികൾ",
    statRelief: "ദുരന്ത നിവാരണ സഹായം",
    statCenters: "പരിശീലന കേന്ദ്രങ്ങൾ",
    aboutKicker: "ഞങ്ങളെക്കുറിച്ച്",
    aboutTitle: "വിശ്വ ഹിന്ദു\nരക്ഷാ പരിഷത്ത്",
    aboutHeroSub: "സമൂഹത്തിന്റെ സംരക്ഷണത്തിനും ശാക്തീകരണത്തിനും പുരോഗതിക്കുമായി സമർപ്പിതമായ മത-സാമൂഹിക സംഘടന.",
    aboutStoryTitle: "ഞങ്ങളുടെ കഥ",
    aboutStory: "രാമനവമി ശുഭദിനത്തിൽ ശ്രീ ഗോപാൽ റായ് സ്ഥാപിച്ച മത-സാമൂഹിക സംഘടനയാണ് വിശ്വ ഹിന്ദു രക്ഷാ പരിഷത്ത് (VHRP). രാജ്യമെമ്പാടുമുള്ള യാത്രകളിൽ, ഹിന്ദു സമൂഹത്തിന്റെ വികസനം വേണ്ടത്ര പുരോഗമിക്കുന്നില്ലെന്ന് അദ്ദേഹം മനസ്സിലാക്കി. ഈ സ്ഥിതി മാറ്റാൻ, ഹിന്ദു ധർമ്മത്തെയും സമൂഹത്തെയും കൂടുതൽ ശക്തവും സംഘടിതവുമായ രൂപത്തിൽ അവതരിപ്പിക്കാൻ അദ്ദേഹം VHRP സ്ഥാപിച്ചു.",
    objectivesTitle: "ഞങ്ങളുടെ പ്രധാന ലക്ഷ്യങ്ങൾ",
    obj1: "ഇന്ത്യയെ ഹിന്ദു രാഷ്ട്രമാക്കുക",
    obj2: "ജാതീയത അവസാനിപ്പിക്കുക",
    obj3: "ബാലവിവാഹം തടയുക",
    obj4: "പാവപ്പെട്ട കുട്ടികൾക്ക് വിദ്യാഭ്യാസം നൽകുക",
    obj5: "ഗോവധശാലകൾ നിരോധിക്കുക",
    obj6: "സാമ്പത്തികമായി പിന്നാക്കം നിൽക്കുന്ന പെൺകുട്ടികളുടെ വിവാഹത്തിന് സഹായം",
    purposeTitle: "ഞങ്ങളുടെ ലക്ഷ്യം",
    purposeBody: "VHRP ഹിന്ദുധർമ്മത്തിന്റെ പൈതൃകവും സംസ്കാരവും മൂല്യങ്ങളും സംരക്ഷിക്കുകയും, സാമൂഹിക പ്രശ്നങ്ങൾ പരിഹരിച്ച് ശക്തമായ സമൂഹം സൃഷ്ടിക്കുകയും ചെയ്യുന്നു.",
    coreValuesTitle: "ഞങ്ങളുടെ അടിസ്ഥാന മൂല്യങ്ങൾ",
    coreValuesBody: "സേവനത്തിലൂടെയും സംസ്കാരത്തിലൂടെയും സാമൂഹിക ഐക്യം ശക്തിപ്പെടുത്തുന്നു. സത്യം, കരുണ, സഹിഷ്ണുത എന്നിവയോടെ സമാധാനപരമായ സഹവർത്തിത്വത്തിൽ വിശ്വസിക്കുന്നു.",
    initiativesTitle: "സ്വാധീനമുള്ള സംരംഭങ്ങൾ",
    initiativesBody: "\"സംസ്കൃതി രക്ഷാ യോജന\" പാരമ്പര്യങ്ങൾ സംരക്ഷിക്കുന്നു, \"ശിശു വികസന കേന്ദ്രം\" യുവാക്കളെ ശാക്തീകരിക്കുന്നു, \"സേവാ കേന്ദ്രം\" ആരോഗ്യ സേവനങ്ങൾ നൽകുന്നു.",
    achievementsTitle: "ഞങ്ങളുടെ നേട്ടങ്ങൾ",
    achievementsBody: "500+ ബോധവൽക്കരണ പരിപാടികൾ, 50,000+ പേർക്ക് ദുരന്ത നിവാരണ സഹായം, യുവാക്കൾക്കായി പരിശീലന കേന്ദ്രങ്ങൾ, പുരാതന ക്ഷേത്രങ്ങൾ സംരക്ഷിക്കാനുള്ള കാമ്പെയ്‌നുകൾ.",
    founderSecTitle: "ഞങ്ങളുടെ സ്ഥാപകൻ",
    founderDesc: "VHRP യുടെ അന്താരാഷ്ട്ര അധ്യക്ഷൻ ശ്രീ ഗോപാൽ റായ് നേതൃപാടവത്തിനും സാമൂഹിക സമർപ്പണത്തിനും പ്രശസ്തനാണ്. സമൂഹത്തെ ശാക്തീകരിക്കുകയും സംസ്കാരം സംരക്ഷിക്കുകയുമാണ് അദ്ദേഹത്തിന്റെ ലക്ഷ്യം.",
    joinCta: "VHRP യിൽ ചേരുക",
    contactTitle: "ബന്ധപ്പെടുക",
    contactIntro: "ചോദ്യങ്ങളുണ്ടോ? പിന്തുണ, അംഗത്വം അല്ലെങ്കിൽ പങ്കാളിത്തത്തിനായി VHRP യെ സമീപിക്കുക.",
    contactCallLabel: "ഫോൺ (ഓഫീസ്)",
    contactMobileLabel: "മൊബൈൽ / ഹെൽപ്പ്‌ലൈൻ",
    contactEmailLabel: "ഇമെയിൽ",
    contactWebsiteLabel: "വെബ്സൈറ്റ്",
    contactAddressLabel: "ഹെഡ് ഓഫീസ്",
    memTitle: "അംഗത്വം തിരഞ്ഞെടുക്കുക",
    memSubtitle: "VHRP യുടെ ദൗത്യത്തെ പിന്തുണയ്ക്കുക. അനുയോജ്യമായ വിഭാഗം തിരഞ്ഞെടുക്കുക.",
    perYear: "/ വർഷം",
    memContinue: "രജിസ്ട്രേഷനിലേക്ക് തുടരുക",
    memUpgrade: "അപ്ഗ്രേഡ് / പുതുക്കുക",
    tierSupporter: "പിന്തുണക്കാരൻ",
    tierFriend: "സുഹൃത്ത്",
    tierAssociate: "അസോസിയേറ്റ്",
    tierActive: "സജീവ അംഗം",
    tierPatron: "രക്ഷാധികാരി",
    tierFounder: "സ്ഥാപക സർക്കിൾ",
    ben1: "ഡിജിറ്റൽ അംഗത്വ ഐഡി",
    ben2: "1 വർഷ കാലാവധി",
    ben3: "വാർത്താക്കുറിപ്പ് അപ്ഡേറ്റുകൾ",
    ben4: "പരിപാടി ക്ഷണങ്ങൾ",
    ben5: "സന്നദ്ധസേവന അവസരങ്ങൾ",
    ben6: "സുഹൃത്ത് വിഭാഗത്തിലെ എല്ലാം",
    ben7: "പരാതിക്ക് മുൻഗണനാ പ്രതികരണം",
    ben8: "പ്രാദേശിക ശാഖാ പ്രവേശനം",
    ben9: "അസോസിയേറ്റ് വിഭാഗത്തിലെ എല്ലാം",
    ben10: "സംസ്ഥാനതല പരിപാടികൾ",
    ben11: "അംഗീകാര സർട്ടിഫിക്കറ്റ്",
    ben12: "സജീവ വിഭാഗത്തിലെ എല്ലാം",
    ben13: "ദേശീയ സമ്മേളന പ്രവേശനം",
    ben14: "നേതൃത്വവുമായി നേരിട്ട് ബന്ധം",
    ben15: "രക്ഷാധികാരി വിഭാഗത്തിലെ എല്ലാം",
    ben16: "ആജീവനാന്ത അംഗീകാരം",
    ben17: "പ്രത്യേക സ്ഥാപക പരിപാടികൾ",
    ben18: "നേതൃത്വത്തിന്റെ വ്യക്തിഗത സ്വീകരണം",
    grvTitle: "പരാതി നൽകുക",
    grvSubtitle: "VHRP യോട് ഒരു പ്രശ്നമോ പരാതിയോ അറിയിക്കുക.",
    grvSubject: "വിഷയം *",
    grvSubjectPh: "ഹ്രസ്വ തലക്കെട്ട്",
    grvCategory: "വിഭാഗം",
    grvLocation: "സ്ഥലം (നഗരം, സംസ്ഥാനം)",
    grvLocationPh: "ഉദാ. കൊച്ചി, കേരളം",
    grvDesc: "പ്രശ്നം വിവരിക്കുക *",
    grvDescPh: "പൂർണ്ണ വിവരങ്ങൾ പങ്കിടുക — എന്ത് സംഭവിച്ചു, എപ്പോൾ, ആരൊക്കെ ഉൾപ്പെട്ടു.",
    grvSubmit: "പരാതി സമർപ്പിക്കുക",
    grvFillReq: "വിഷയവും വിവരണവും പൂരിപ്പിക്കുക",
    grvOkTitle: "പരാതി ലഭിച്ചു",
    grvOkSub: "നിങ്ങളുടെ പരാതി രേഖപ്പെടുത്തി. ഞങ്ങളുടെ ടീം 3 പ്രവൃത്തി ദിവസങ്ങൾക്കുള്ളിൽ ബന്ധപ്പെടും.",
    grvTicket: "ടിക്കറ്റ് ഐഡി",
    grvAnother: "മറ്റൊരു പരാതി നൽകുക",
    catLand: "ഭൂമി തർക്കം",
    catCorruption: "അഴിമതി",
    catPublic: "പൊതു സേവനം",
    catWomen: "സ്ത്രീ സുരക്ഷ",
    catCommunal: "വർഗീയ പ്രശ്നം",
    catOther: "മറ്റുള്ളവ",
    regTitle: "അംഗത്വ വിവരങ്ങൾ",
    regTierLabel: "വിഭാഗം",
    regPhotoAdd: "ഫോട്ടോ ചേർക്കുക",
    regPhotoHint: "പാസ്പോർട്ട് ഫോട്ടോ (3:4)\nനിങ്ങളുടെ ഡിജിറ്റൽ ഐഡി കാർഡിൽ ഉപയോഗിക്കും.",
    regFullName: "മുഴുവൻ പേര് *",
    regFather: "പിതാവിന്റെ / രക്ഷിതാവിന്റെ പേര് *",
    regAddress: "വിലാസം *",
    regPhone: "ഫോൺ *",
    regDob: "ജനന തീയതി *",
    regEmail: "ഇമെയിൽ",
    regDesignation: "പദവി",
    regBlood: "രക്തഗ്രൂപ്പ്",
    regAadhaar: "ആധാർ നമ്പർ *",
    regPay: "പണമടയ്ക്കാൻ തുടരുക",
    regFillReq: "ആവശ്യമായ എല്ലാ ഫീൽഡുകളും പൂരിപ്പിക്കുക",
    regPhotoPerm: "ഫോട്ടോ അനുമതി ആവശ്യമാണ്",
    regDefaultDesig: "പൊതു അംഗം",
    payTitle: "പേയ്മെന്റ്",
    payCreating: "നിങ്ങളുടെ ഓർഡർ സൃഷ്ടിക്കുന്നു…",
    payAmount: "അടയ്ക്കേണ്ട തുക",
    payDemo: "ഡെമോ മോഡ്: Razorpay കീകൾ ക്രമീകരിച്ചിട്ടില്ല. \"പണമടയ്ക്കുക\" ടാപ്പ് ചെയ്താൽ വിജയകരമായ പേയ്മെന്റ് അനുകരിക്കും.",
    paySimulate: "പേയ്മെന്റ് അനുകരിക്കുക",
    payNow: "ഇപ്പോൾ അടയ്ക്കുക",
    paySecured: "🔒 Razorpay സുരക്ഷിതം",
    payProcessing: "പേയ്മെന്റ് പ്രോസസ്സ് ചെയ്യുന്നു…",
    payFailTitle: "പേയ്മെന്റ് പരാജയപ്പെട്ടു",
    payFailSub: "എന്തോ കുഴപ്പം സംഭവിച്ചു. വീണ്ടും ശ്രമിക്കുക.",
    payBack: "മടങ്ങുക",
    payOkTitle: "നിങ്ങൾ അംഗമായി! 🎉",
    payOkSub: "പേയ്മെന്റ് ലഭിച്ചു. നിങ്ങളുടെ ഡിജിറ്റൽ ഐഡി കാർഡ് തയ്യാറാണ്.",
    payViewCard: "എന്റെ ഡിജിറ്റൽ കാർഡ് കാണുക",
    cardHeadTitle: "എന്റെ ഡിജിറ്റൽ ഐഡി",
    cardScan: "പരിശോധിക്കാൻ സ്കാൻ ചെയ്യുക",
    cardScanHint: "പരിശോധകർക്ക് ഈ കോഡ് സ്കാൻ ചെയ്ത് നിങ്ങളുടെ സജീവ അംഗത്വം സ്ഥിരീകരിക്കാം.",
    cardEmptyTitle: "സജീവ അംഗത്വം ഇല്ല",
    cardEmptySub: "ഡിജിറ്റൽ ഐഡി കാർഡ് ലഭിക്കാൻ രജിസ്ട്രേഷൻ പൂർത്തിയാക്കുക.",
    cardGet: "അംഗത്വം നേടുക",
    dMembershipId: "അംഗത്വ ഐഡി",
    dTier: "വിഭാഗം",
    dFullName: "മുഴുവൻ പേര്",
    dFather: "പിതാവിന്റെ പേര്",
    dDob: "ജനന തീയതി",
    dPhone: "ഫോൺ",
    dAddress: "വിലാസം",
    cardShareMsg: "ഞാൻ ഇപ്പോൾ വിശ്വ ഹിന്ദു രക്ഷാ പരിഷത്തിന്റെ അംഗമാണ്! അംഗത്വ ഐഡി:",
    cardOfficialSub: "ഡിജിറ്റൽ അംഗത്വ കാർഡ്",
    cardValidUntil: "കാലാവധി",
    cardSo: "പിതാവ്",
    cardBlood: "രക്തം",
    cardCity: "നഗരം",
    cardState: "സംസ്ഥാനം",
    profCardSection: "എന്റെ ഡിജിറ്റൽ കാർഡ്",
    profBecome: "അംഗമാകൂ",
    profBecomeSub: "മിനിറ്റുകൾക്കുള്ളിൽ ഔദ്യോഗിക ഡിജിറ്റൽ ഐഡി കാർഡ് നേടുക.",
    profComplaints: "എന്റെ പരാതികൾ",
    profMore: "കൂടുതൽ",
    profAboutItem: "VHRP യെക്കുറിച്ച്",
    profContactItem: "ബന്ധപ്പെടുക",
    profPrivacy: "സ്വകാര്യതാ നയം",
    profLanguageItem: "ഭാഷ / Language",
    profLogout: "ലോഗൗട്ട്",
    newsHeader: "വാർത്ത",
    verifyTile: "അംഗത്തെ പരിശോധിക്കുക",
    verifyTitle: "അംഗ പരിശോധന",
    verifyIntro: "അംഗത്തിന്റെ QR കോഡ് സ്കാൻ ചെയ്ത് ഉടനടി അംഗത്വം സ്ഥിരീകരിക്കുക. ക്യാമറ സ്കാനിംഗിന് മാത്രമേ ഉപയോഗിക്കൂ.",
    verifyEnable: "ക്യാമറ ഓണാക്കി സ്കാൻ ചെയ്യുക",
    verifyDeniedMsg: "ക്യാമറ അനുമതി നിരസിച്ചു. താഴെ അംഗത്വ ഐഡി ടൈപ്പ് ചെയ്യുക, അല്ലെങ്കിൽ ക്രമീകരണങ്ങളിൽ ക്യാമറ ഓണാക്കുക.",
    verifyOpenSettings: "ക്രമീകരണങ്ങൾ തുറക്കുക",
    verifyScanHint: "ക്യാമറ അംഗത്തിന്റെ QR കോഡിലേക്ക് ചൂണ്ടുക",
    verifyManual: "അല്ലെങ്കിൽ അംഗത്വ ഐഡി നൽകുക",
    verifyCheck: "പരിശോധിക്കുക",
    verifyChecking: "പരിശോധിക്കുന്നു…",
    verifyValid: "സാധുവായ അംഗം",
    verifyExpired: "അംഗത്വം കാലഹരണപ്പെട്ടു",
    verifyInvalid: "സാധുവല്ലാത്ത അംഗം",
    verifyNotFound: "ഈ ഐഡിയിൽ അംഗത്തെ കണ്ടെത്തിയില്ല.",
    verifyScanAgain: "മറ്റൊന്ന് പരിശോധിക്കുക",
    verifyWebHint: "ക്യാമറ സ്കാനിംഗ് മൊബൈൽ ആപ്പിൽ പ്രവർത്തിക്കും. താഴെ അംഗത്വ ഐഡി നൽകുക.",
    cardSave: "ചിത്രം സേവ് ചെയ്യുക",
    cardShare: "പങ്കിടുക",
    cardSaved: "കാർഡ് ചിത്രം ഗാലറിയിൽ സേവ് ചെയ്തു",
    cardSaveFailed: "കാർഡ് സേവ് ചെയ്യാനായില്ല",
    cardPermPhotos: "കാർഡ് ഗാലറിയിൽ സേവ് ചെയ്യാൻ ഫോട്ടോ അനുമതി നൽകുക",
    trackTitle: "പരാതി നില",
    stReceived: "ലഭിച്ചു",
    stInReview: "പരിശോധനയിൽ",
    stResolved: "പരിഹരിച്ചു",
    trackDesc: "വിവരണം",
    trackLocation: "സ്ഥലം",
    eventsTitle: "വരാനിരിക്കുന്ന പരിപാടികൾ",
    eventsEmpty: "ഇപ്പോൾ വരാനിരിക്കുന്ന പരിപാടികളില്ല. ഉടൻ വീണ്ടും നോക്കുക!",
    rsvpGo: "ഞാൻ പങ്കെടുക്കും",
    rsvpGoing: "നിങ്ങൾ പോകുന്നു ✓",
    attending: "പങ്കെടുക്കുന്നു",
    seeAll: "എല്ലാം കാണുക",
    renewSoonTitle: "അംഗത്വം ഉടൻ കാലഹരണപ്പെടും",
    renewSoonBody: "നിങ്ങളുടെ അംഗത്വം {days} ദിവസത്തിനുള്ളിൽ കാലഹരണപ്പെടും. ഡിജിറ്റൽ ഐഡി സജീവമായി നിലനിർത്താൻ പുതുക്കുക.",
    renewExpiredTitle: "അംഗത്വം കാലഹരണപ്പെട്ടു",
    renewExpiredBody: "നിങ്ങളുടെ അംഗത്വം കാലഹരണപ്പെട്ടു. ഡിജിറ്റൽ ഐഡി വീണ്ടും സജീവമാക്കാൻ ഇപ്പോൾ പുതുക്കുക.",
    renewCta: "ഇപ്പോൾ പുതുക്കുക",
    evToday: "ഇന്നാണ്!",
    evTomorrow: "നാളെയാണ്!",
    regCity: "നഗരം *",
    regState: "സംസ്ഥാനം *",
    regCountry: "രാജ്യം",
    regSocial: "സോഷ്യൽ മീഡിയ ലിങ്ക്",
    regSocialPh: "ഉദാ. https://facebook.com/yourprofile",
    regAadhaarInvalid: "സാധുവായ 12-അക്ക ആധാർ നമ്പർ നൽകുക",
    otpSend: "OTP അയയ്ക്കുക",
    otpSent: "നിങ്ങളുടെ നമ്പറിലേക്ക് OTP അയച്ചു",
    otpEnterPh: "6-അക്ക OTP",
    otpVerify: "പരിശോധിക്കുക",
    otpVerified: "പരിശോധിച്ചു ✓",
    otpDemoNote: "ഡെമോ മോഡ് — നിങ്ങളുടെ OTP:",
    otpRequired: "ആദ്യം OTP ഉപയോഗിച്ച് ഫോൺ നമ്പർ പരിശോധിക്കുക",
    dirTile: "അംഗ ഡയറക്ടറി",
    dirTotalLabel: "രജിസ്റ്റർ ചെയ്ത അംഗങ്ങൾ",
    dirSearchPh: "പേര്, നഗരം അല്ലെങ്കിൽ സംസ്ഥാനം തിരയുക…",
    dirAll: "എല്ലാം",
    dirIndia: "ഇന്ത്യ",
    dirIntl: "അന്തർദേശീയം",
    dirLockedTitle: "അംഗങ്ങൾക്ക് മാത്രം",
    dirLockedSub: "അംഗ ഡയറക്ടറി സജീവ അംഗങ്ങൾക്ക് മാത്രം. ഇന്ത്യയിലും വിദേശത്തുമുള്ള VHRP അംഗങ്ങളുമായി ബന്ധപ്പെടാൻ അംഗത്വം നേടുക.",
    dirEmpty: "അംഗങ്ങളെ കണ്ടെത്തിയില്ല",
    grvPhotos: "തെളിവായി ഫോട്ടോകൾ ചേർക്കുക (ഓപ്ഷണൽ, പരമാവധി 3)",
    trackPhotos: "ചേർത്ത ഫോട്ടോകൾ",
  },
  te: {
    orgName: "విశ్వ హిందూ రక్షా పరిషత్",
    motto: "యతో ధర్మః తతో జయః",
    back: "వెనుకకు",
    loadError: "డేటా లోడ్ కాలేదు. మీ కనెక్షన్ తనిఖీ చేయండి.",
    retry: "మళ్లీ ప్రయత్నించండి",
    newBadge: "కొత్తది",
    videosTitle: "వీడియోలు",
    videosEmpty: "వీడియోలు లేవు — మా YouTube ఛానెల్ చూడండి",
    desigMember: "సభ్యుడు",
    desigGeneral: "సాధారణ సభ్యుడు",
    contactHQ: "ఇతర బాధ్యతాయుత సభ్యత్వాల కోసం హెడ్ ఆఫీస్‌ను సంప్రదించండి",
    promoTill: "అక్టోబర్ 4 వరకు మాత్రమే",
    inviteCopied: "ఆహ్వానం కాపీ అయింది — WhatsApp-లో పేస్ట్ చేయండి",
    share: "షేర్ చేయండి",
    copied: "క్లిప్‌బోర్డ్‌కు కాపీ అయింది",
    photoVerifying: "AI మీ ఫోటోను ధృవీకరిస్తోంది…",
    photoRejected: "ఫోటో తిరస్కరించబడింది",
    aadhaarFront: "ఆధార్ ముందు ఫోటో *",
    aadhaarBack: "ఆధార్ వెనుక ఫోటో *",
    aadhaarPhotosReq: "ఆధార్ ముందు & వెనుక ఫోటోలు తప్పనిసరి",
    aadhaarAdminOnly: "VHRP అడ్మిన్‌లకు మాత్రమే కనిపిస్తుంది",
    tabHome: "హోమ్",
    tabMembership: "సభ్యత్వం",
    tabGrievance: "ఫిర్యాదు",
    tabProfile: "ప్రొఫైల్",
    langTitle: "మీ భాషను ఎంచుకోండి",
    langSubtitle: "మీకు అత్యంత సౌకర్యవంతమైన భాషను ఎంచుకోండి",
    langContinue: "కొనసాగించండి",
    loginTagline: "సభ్యత్వం • ఫిర్యాదు • సేవ",
    loginGoogle: "Google తో కొనసాగించండి",
    loginLegal: "కొనసాగించడం ద్వారా VHRP నిబంధనలు\nమరియు గోప్యతా విధానాన్ని అంగీకరిస్తున్నారు.",
    greet: "నమస్తే 🙏",
    defaultMember: "సభ్యుడు",
    heroTitle: "సమాజ రక్షణ, సాధికారత మరియు ప్రగతి",
    heroSub: "రామనవమి శుభ సందర్భంగా శ్రీ గోపాల్ రాయ్ చే స్థాపించబడింది",
    heroCta: "సభ్యులు కండి",
    quickGrievance: "ఫిర్యాదు",
    quickPlans: "సభ్యత్వం",
    quickAbout: "మా గురించి",
    quickContact: "సంప్రదించండి",
    unlockTitle: "సభ్యత్వం పొందండి",
    unlockTitlePending: "సభ్యత్వం పూర్తి చేయండి",
    unlockSub: "VHRP లో చేరి వెంటనే అధికారిక డిజిటల్ ఐడి కార్డ్ పొందండి.",
    unlockSubPending: "దాదాపు పూర్తయింది — చెల్లింపు పూర్తి చేసి డిజిటల్ ఐడి కార్డ్ పొందండి.",
    founderMsgTitle: "వ్యవస్థాపకుని సందేశం",
    founderName: "శ్రీ గోపాల్ రాయ్",
    founderRole: "అంతర్జాతీయ అధ్యక్షులు (VHRP)",
    founderQuote: "సమాజాన్ని బలోపేతం చేయడం, మన సంస్కృతిని రక్షించడం, ఐక్యతా భావాన్ని పెంపొందించడం మా లక్ష్యం.",
    galleryTitle: "ఫోటో గ్యాలరీ",
    latestUpdates: "తాజా వార్తలు & కార్యక్రమాలు",
    statPrograms: "అవగాహన కార్యక్రమాలు",
    statRelief: "విపత్తు సహాయం",
    statCenters: "శిక్షణా కేంద్రాలు",
    aboutKicker: "మా గురించి",
    aboutTitle: "విశ్వ హిందూ\nరక్షా పరిషత్",
    aboutHeroSub: "సమాజ రక్షణ, సాధికారత మరియు ప్రగతి కోసం అంకితమైన మత మరియు సామాజిక సంస్థ.",
    aboutStoryTitle: "మా కథ",
    aboutStory: "విశ్వ హిందూ రక్షా పరిషత్ (VHRP) అనేది రామనవమి శుభ సందర్భంగా శ్రీ గోపాల్ రాయ్ స్థాపించిన మత మరియు సామాజిక సంస్థ. దేశవ్యాప్త పర్యటనలలో, హిందూ సమాజ అభివృద్ధి ఆశించిన విధంగా జరగడం లేదని ఆయన గ్రహించారు. ఈ పరిస్థితిని మార్చడానికి, హిందూ ధర్మాన్ని మరియు సమాజాన్ని మరింత బలంగా, వ్యవస్థీకృతంగా ముందుకు తీసుకెళ్లడానికి VHRP ను స్థాపించారు.",
    objectivesTitle: "మా ముఖ్య లక్ష్యాలు",
    obj1: "భారతదేశాన్ని హిందూ రాష్ట్రంగా చేయడం",
    obj2: "కులతత్వాన్ని అంతం చేయడం",
    obj3: "బాల్య వివాహాల నిషేధం",
    obj4: "పేద పిల్లలకు విద్య అందించడం",
    obj5: "గోవధశాలల నిషేధం",
    obj6: "ఆర్థికంగా బలహీన కుటుంబాల ఆడపిల్లల వివాహాలకు సహాయం",
    purposeTitle: "మా లక్ష్యం",
    purposeBody: "VHRP హిందూ ధర్మ వారసత్వం, సంస్కృతి మరియు విలువలను రక్షిస్తుంది, సంప్రదాయాలను పరిరక్షిస్తుంది, సామాజిక సమస్యలను పరిష్కరించి బలమైన సమాజాన్ని నిర్మిస్తుంది.",
    coreValuesTitle: "మా మౌలిక విలువలు",
    coreValuesBody: "సేవ మరియు సంస్కృతి ద్వారా సమాజ ఐక్యతను బలోపేతం చేస్తాము. సత్యం, కరుణ, సహనంతో శాంతియుత సహజీవనాన్ని విశ్వసిస్తాము.",
    initiativesTitle: "ప్రభావవంతమైన కార్యక్రమాలు",
    initiativesBody: "\"సంస్కృతి రక్షా యోజన\" సంప్రదాయాలను పరిరక్షిస్తుంది, \"బాల వికాస కేంద్రం\" యువతను శక్తివంతం చేస్తుంది, \"సేవా కేంద్రం\" ఆరోగ్య సేవలు అందిస్తుంది.",
    achievementsTitle: "మా విజయాలు",
    achievementsBody: "500+ అవగాహన కార్యక్రమాలు, 50,000+ మందికి విపత్తు సహాయం, యువత కోసం శిక్షణా కేంద్రాలు, పురాతన దేవాలయాల పరిరక్షణ ఉద్యమాలు.",
    founderSecTitle: "మా వ్యవస్థాపకులు",
    founderDesc: "VHRP అంతర్జాతీయ అధ్యక్షులు శ్రీ గోపాల్ రాయ్ నాయకత్వ సామర్థ్యం మరియు సమాజ సేవకు ప్రసిద్ధులు. సమాజాన్ని శక్తివంతం చేయడం, సంస్కృతిని రక్షించడం ఆయన లక్ష్యం.",
    joinCta: "VHRP లో చేరండి",
    contactTitle: "సంప్రదించండి",
    contactIntro: "ప్రశ్నలు ఉన్నాయా? మద్దతు, సభ్యత్వం లేదా భాగస్వామ్యం కోసం VHRP ను సంప్రదించండి.",
    contactCallLabel: "ఫోన్ (కార్యాలయం)",
    contactMobileLabel: "మొబైల్ / హెల్ప్‌లైన్",
    contactEmailLabel: "ఇమెయిల్",
    contactWebsiteLabel: "వెబ్‌సైట్",
    contactAddressLabel: "ప్రధాన కార్యాలయం",
    memTitle: "సభ్యత్వం ఎంచుకోండి",
    memSubtitle: "VHRP లక్ష్యానికి మద్దతు ఇవ్వండి. మీకు తగిన స్థాయిని ఎంచుకోండి.",
    perYear: "/ సంవత్సరం",
    memContinue: "నమోదుకు కొనసాగండి",
    memUpgrade: "అప్‌గ్రేడ్ / పునరుద్ధరణ",
    tierSupporter: "మద్దతుదారు",
    tierFriend: "మిత్రుడు",
    tierAssociate: "అసోసియేట్",
    tierActive: "క్రియాశీల సభ్యుడు",
    tierPatron: "పోషకుడు",
    tierFounder: "వ్యవస్థాపక వృత్తం",
    ben1: "డిజిటల్ సభ్యత్వ ఐడి",
    ben2: "1 సంవత్సర చెల్లుబాటు",
    ben3: "వార్తాలేఖ నవీకరణలు",
    ben4: "కార్యక్రమ ఆహ్వానాలు",
    ben5: "స్వచ్ఛంద సేవా అవకాశాలు",
    ben6: "మిత్రుడు స్థాయిలోని అన్నీ",
    ben7: "ఫిర్యాదుకు ప్రాధాన్యత స్పందన",
    ben8: "స్థానిక శాఖ ప్రవేశం",
    ben9: "అసోసియేట్ స్థాయిలోని అన్నీ",
    ben10: "రాష్ట్ర స్థాయి కార్యక్రమాలు",
    ben11: "గుర్తింపు ధృవీకరణ పత్రం",
    ben12: "క్రియాశీల స్థాయిలోని అన్నీ",
    ben13: "జాతీయ సదస్సు ప్రవేశం",
    ben14: "నాయకత్వంతో ప్రత్యక్ష సంబంధం",
    ben15: "పోషకుడు స్థాయిలోని అన్నీ",
    ben16: "జీవితకాల గుర్తింపు",
    ben17: "ప్రత్యేక వ్యవస్థాపక కార్యక్రమాలు",
    ben18: "నాయకత్వం వ్యక్తిగత స్వాగతం",
    grvTitle: "ఫిర్యాదు నమోదు చేయండి",
    grvSubtitle: "VHRP కు సమస్య లేదా ఫిర్యాదు తెలియజేయండి.",
    grvSubject: "విషయం *",
    grvSubjectPh: "సంక్షిప్త శీర్షిక",
    grvCategory: "వర్గం",
    grvLocation: "ప్రదేశం (నగరం, రాష్ట్రం)",
    grvLocationPh: "ఉదా. హైదరాబాద్, తెలంగాణ",
    grvDesc: "సమస్యను వివరించండి *",
    grvDescPh: "పూర్తి వివరాలు పంచుకోండి — ఏమి జరిగింది, ఎప్పుడు, ఎవరు పాల్గొన్నారు.",
    grvSubmit: "ఫిర్యాదు సమర్పించండి",
    grvFillReq: "దయచేసి విషయం మరియు వివరణ నింపండి",
    grvOkTitle: "ఫిర్యాదు అందింది",
    grvOkSub: "మీ ఫిర్యాదు నమోదైంది. మా బృందం 3 పని దినాల్లో సంప్రదిస్తుంది.",
    grvTicket: "టికెట్ ఐడి",
    grvAnother: "మరో ఫిర్యాదు నమోదు చేయండి",
    catLand: "భూ వివాదం",
    catCorruption: "అవినీతి",
    catPublic: "ప్రజా సేవ",
    catWomen: "మహిళా భద్రత",
    catCommunal: "మతపరమైన సమస్య",
    catOther: "ఇతర",
    regTitle: "సభ్యత్వ వివరాలు",
    regTierLabel: "స్థాయి",
    regPhotoAdd: "ఫోటో జోడించండి",
    regPhotoHint: "పాస్‌పోర్ట్ ఫోటో (3:4)\nమీ డిజిటల్ ఐడి కార్డ్‌పై ఉపయోగించబడుతుంది.",
    regFullName: "పూర్తి పేరు *",
    regFather: "తండ్రి / సంరక్షకుని పేరు *",
    regAddress: "చిరునామా *",
    regPhone: "ఫోన్ *",
    regDob: "పుట్టిన తేదీ *",
    regEmail: "ఇమెయిల్",
    regDesignation: "హోదా",
    regBlood: "రక్త వర్గం",
    regAadhaar: "ఆధార్ నంబర్ *",
    regPay: "చెల్లింపుకు కొనసాగండి",
    regFillReq: "అవసరమైన అన్ని ఫీల్డ్‌లు నింపండి",
    regPhotoPerm: "ఫోటో అనుమతి అవసరం",
    regDefaultDesig: "సాధారణ సభ్యుడు",
    payTitle: "చెల్లింపు",
    payCreating: "మీ ఆర్డర్ సృష్టించబడుతోంది…",
    payAmount: "చెల్లించవలసిన మొత్తం",
    payDemo: "డెమో మోడ్: Razorpay కీలు కాన్ఫిగర్ చేయబడలేదు. \"చెల్లించు\" నొక్కితే విజయవంతమైన చెల్లింపు అనుకరించబడుతుంది.",
    paySimulate: "చెల్లింపు అనుకరించండి",
    payNow: "ఇప్పుడే చెల్లించండి",
    paySecured: "🔒 Razorpay ద్వారా సురక్షితం",
    payProcessing: "చెల్లింపు ప్రాసెస్ అవుతోంది…",
    payFailTitle: "చెల్లింపు విఫలమైంది",
    payFailSub: "ఏదో తప్పు జరిగింది. మళ్లీ ప్రయత్నించండి.",
    payBack: "వెనుకకు వెళ్ళండి",
    payOkTitle: "మీరు సభ్యులయ్యారు! 🎉",
    payOkSub: "చెల్లింపు అందింది. మీ డిజిటల్ ఐడి కార్డ్ సిద్ధంగా ఉంది.",
    payViewCard: "నా డిజిటల్ కార్డ్ చూడండి",
    cardHeadTitle: "నా డిజిటల్ ఐడి",
    cardScan: "ధృవీకరణకు స్కాన్ చేయండి",
    cardScanHint: "ధృవీకరణదారులు ఈ కోడ్‌ను స్కాన్ చేసి మీ క్రియాశీల సభ్యత్వాన్ని నిర్ధారించవచ్చు.",
    cardEmptyTitle: "క్రియాశీల సభ్యత్వం లేదు",
    cardEmptySub: "డిజిటల్ ఐడి కార్డ్ పొందడానికి నమోదు పూర్తి చేయండి.",
    cardGet: "సభ్యత్వం పొందండి",
    dMembershipId: "సభ్యత్వ ఐడి",
    dTier: "స్థాయి",
    dFullName: "పూర్తి పేరు",
    dFather: "తండ్రి పేరు",
    dDob: "పుట్టిన తేదీ",
    dPhone: "ఫోన్",
    dAddress: "చిరునామా",
    cardShareMsg: "నేను ఇప్పుడు విశ్వ హిందూ రక్షా పరిషత్ సభ్యుడిని! సభ్యత్వ ఐడి:",
    cardOfficialSub: "డిజిటల్ సభ్యత్వ కార్డ్",
    cardValidUntil: "చెల్లుబాటు",
    cardSo: "తండ్రి",
    cardBlood: "రక్తం",
    cardCity: "నగరం",
    cardState: "రాష్ట్రం",
    profCardSection: "నా డిజిటల్ కార్డ్",
    profBecome: "సభ్యులు కండి",
    profBecomeSub: "నిమిషాల్లో అధికారిక డిజిటల్ ఐడి కార్డ్ పొందండి.",
    profComplaints: "నా ఫిర్యాదులు",
    profMore: "మరిన్ని",
    profAboutItem: "VHRP గురించి",
    profContactItem: "సంప్రదించండి",
    profPrivacy: "గోప్యతా విధానం",
    profLanguageItem: "భాష / Language",
    profLogout: "లాగ్ అవుట్",
    newsHeader: "వార్త",
    verifyTile: "సభ్యుడిని ధృవీకరించండి",
    verifyTitle: "సభ్య ధృవీకరణ",
    verifyIntro: "సభ్యుని QR కోడ్‌ను స్కాన్ చేసి వెంటనే సభ్యత్వాన్ని నిర్ధారించండి. కెమెరా స్కానింగ్‌కు మాత్రమే ఉపయోగించబడుతుంది.",
    verifyEnable: "కెమెరా ఆన్ చేసి స్కాన్ చేయండి",
    verifyDeniedMsg: "కెమెరా అనుమతి నిరాకరించబడింది. క్రింద సభ్యత్వ ఐడి టైప్ చేయండి, లేదా సెట్టింగ్‌లలో కెమెరా ఆన్ చేయండి.",
    verifyOpenSettings: "సెట్టింగ్‌లు తెరవండి",
    verifyScanHint: "కెమెరాను సభ్యుని QR కోడ్‌పై ఉంచండి",
    verifyManual: "లేదా సభ్యత్వ ఐడి నమోదు చేయండి",
    verifyCheck: "ధృవీకరించండి",
    verifyChecking: "ధృవీకరిస్తోంది…",
    verifyValid: "చెల్లుబాటు అయ్యే సభ్యుడు",
    verifyExpired: "సభ్యత్వం గడువు ముగిసింది",
    verifyInvalid: "చెల్లని సభ్యుడు",
    verifyNotFound: "ఈ ఐడితో సభ్యుడు కనబడలేదు.",
    verifyScanAgain: "మరొకటి ధృవీకరించండి",
    verifyWebHint: "కెమెరా స్కానింగ్ మొబైల్ యాప్‌లో పనిచేస్తుంది. క్రింద సభ్యత్వ ఐడి నమోదు చేయండి.",
    cardSave: "చిత్రాన్ని సేవ్ చేయండి",
    cardShare: "షేర్ చేయండి",
    cardSaved: "కార్డ్ చిత్రం గ్యాలరీలో సేవ్ అయింది",
    cardSaveFailed: "కార్డ్ సేవ్ చేయలేకపోయాము",
    cardPermPhotos: "కార్డ్‌ను గ్యాలరీలో సేవ్ చేయడానికి ఫోటో అనుమతి ఇవ్వండి",
    trackTitle: "ఫిర్యాదు స్థితి",
    stReceived: "అందింది",
    stInReview: "సమీక్షలో",
    stResolved: "పరిష్కరించబడింది",
    trackDesc: "వివరణ",
    trackLocation: "ప్రదేశం",
    eventsTitle: "రాబోయే కార్యక్రమాలు",
    eventsEmpty: "ప్రస్తుతం రాబోయే కార్యక్రమాలు లేవు. త్వరలో చూడండి!",
    rsvpGo: "నేను హాజరవుతాను",
    rsvpGoing: "మీరు వెళ్తున్నారు ✓",
    attending: "హాజరవుతున్నారు",
    seeAll: "అన్నీ చూడండి",
    renewSoonTitle: "సభ్యత్వం త్వరలో ముగుస్తుంది",
    renewSoonBody: "మీ సభ్యత్వం {days} రోజుల్లో ముగుస్తుంది. డిజిటల్ ఐడిని యాక్టివ్‌గా ఉంచడానికి పునరుద్ధరించండి.",
    renewExpiredTitle: "సభ్యత్వం ముగిసింది",
    renewExpiredBody: "మీ సభ్యత్వం ముగిసింది. డిజిటల్ ఐడిని తిరిగి యాక్టివేట్ చేయడానికి ఇప్పుడే పునరుద్ధరించండి.",
    renewCta: "ఇప్పుడే పునరుద్ధరించండి",
    evToday: "ఈరోజే!",
    evTomorrow: "రేపే!",
    regCity: "నగరం *",
    regState: "రాష్ట్రం *",
    regCountry: "దేశం",
    regSocial: "సోషల్ మీడియా లింక్",
    regSocialPh: "ఉదా. https://facebook.com/yourprofile",
    regAadhaarInvalid: "చెల్లుబాటు అయ్యే 12-అంకెల ఆధార్ నంబర్ నమోదు చేయండి",
    otpSend: "OTP పంపండి",
    otpSent: "మీ నంబర్‌కు OTP పంపబడింది",
    otpEnterPh: "6-అంకెల OTP",
    otpVerify: "ధృవీకరించండి",
    otpVerified: "ధృవీకరించబడింది ✓",
    otpDemoNote: "డెమో మోడ్ — మీ OTP:",
    otpRequired: "ముందుగా OTP తో ఫోన్ నంబర్‌ను ధృవీకరించండి",
    dirTile: "సభ్యుల డైరెక్టరీ",
    dirTotalLabel: "నమోదిత సభ్యులు",
    dirSearchPh: "పేరు, నగరం లేదా రాష్ట్రం వెతకండి…",
    dirAll: "అన్నీ",
    dirIndia: "భారతదేశం",
    dirIntl: "అంతర్జాతీయం",
    dirLockedTitle: "సభ్యులకు మాత్రమే",
    dirLockedSub: "సభ్యుల డైరెక్టరీ క్రియాశీల సభ్యులకు మాత్రమే అందుబాటులో ఉంటుంది. భారతదేశం మరియు విదేశాల్లోని VHRP సభ్యులతో అనుసంధానం కావడానికి సభ్యత్వం పొందండి.",
    dirEmpty: "సభ్యులు కనబడలేదు",
    grvPhotos: "సాక్ష్యంగా ఫోటోలు జోడించండి (ఐచ్ఛికం, గరిష్టంగా 3)",
    trackPhotos: "జోడించిన ఫోటోలు",
  },
  kn: {
    orgName: "ವಿಶ್ವ ಹಿಂದೂ ರಕ್ಷಾ ಪರಿಷತ್",
    motto: "ಯತೋ ಧರ್ಮಃ ತತೋ ಜಯಃ",
    back: "ಹಿಂದೆ",
    loadError: "ಡೇಟಾ ಲೋಡ್ ಆಗಲಿಲ್ಲ. ನಿಮ್ಮ ಸಂಪರ್ಕವನ್ನು ಪರಿಶೀಲಿಸಿ.",
    retry: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    newBadge: "ಹೊಸದು",
    videosTitle: "ವೀಡಿಯೊಗಳು",
    videosEmpty: "ವೀಡಿಯೊಗಳಿಲ್ಲ — ನಮ್ಮ YouTube ಚಾನಲ್ ನೋಡಿ",
    desigMember: "ಸದಸ್ಯ",
    desigGeneral: "ಸಾಮಾನ್ಯ ಸದಸ್ಯ",
    contactHQ: "ಇತರ ಜವಾಬ್ದಾರಿಯುತ ಸದಸ್ಯತ್ವಗಳಿಗೆ ಮುಖ್ಯ ಕಚೇರಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ",
    promoTill: "ಅಕ್ಟೋಬರ್ 4ರವರೆಗೆ ಮಾತ್ರ",
    inviteCopied: "ಆಹ್ವಾನ ನಕಲಿಸಲಾಗಿದೆ — WhatsApp-ನಲ್ಲಿ ಅಂಟಿಸಿ",
    share: "ಹಂಚಿಕೊಳ್ಳಿ",
    copied: "ಕ್ಲಿಪ್‌ಬೋರ್ಡ್‌ಗೆ ನಕಲಿಸಲಾಗಿದೆ",
    photoVerifying: "AI ನಿಮ್ಮ ಫೋಟೋ ಪರಿಶೀಲಿಸುತ್ತಿದೆ…",
    photoRejected: "ಫೋಟೋ ತಿರಸ್ಕರಿಸಲಾಗಿದೆ",
    aadhaarFront: "ಆಧಾರ್ ಮುಂಭಾಗದ ಫೋಟೋ *",
    aadhaarBack: "ಆಧಾರ್ ಹಿಂಭಾಗದ ಫೋಟೋ *",
    aadhaarPhotosReq: "ಆಧಾರ್ ಮುಂಭಾಗ & ಹಿಂಭಾಗದ ಫೋಟೋಗಳು ಕಡ್ಡಾಯ",
    aadhaarAdminOnly: "VHRP ನಿರ್ವಾಹಕರಿಗೆ ಮಾತ್ರ ಗೋಚರಿಸುತ್ತದೆ",
    tabHome: "ಮುಖಪುಟ",
    tabMembership: "ಸದಸ್ಯತ್ವ",
    tabGrievance: "ದೂರು",
    tabProfile: "ಪ್ರೊಫೈಲ್",
    langTitle: "ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆರಿಸಿ",
    langSubtitle: "ನಿಮಗೆ ಅನುಕೂಲಕರವಾದ ಭಾಷೆಯನ್ನು ಆರಿಸಿ",
    langContinue: "ಮುಂದುವರಿಸಿ",
    loginTagline: "ಸದಸ್ಯತ್ವ • ದೂರು • ಸೇವೆ",
    loginGoogle: "Google ನೊಂದಿಗೆ ಮುಂದುವರಿಸಿ",
    loginLegal: "ಮುಂದುವರಿಸುವ ಮೂಲಕ VHRP ನಿಯಮಗಳು\nಮತ್ತು ಗೌಪ್ಯತಾ ನೀತಿಯನ್ನು ಒಪ್ಪುತ್ತೀರಿ.",
    greet: "ನಮಸ್ತೆ 🙏",
    defaultMember: "ಸದಸ್ಯ",
    heroTitle: "ಸಮಾಜದ ರಕ್ಷಣೆ, ಸಬಲೀಕರಣ ಮತ್ತು ಪ್ರಗತಿ",
    heroSub: "ರಾಮನವಮಿ ಶುಭ ಸಂದರ್ಭದಲ್ಲಿ ಶ್ರೀ ಗೋಪಾಲ್ ರಾಯ್ ಅವರಿಂದ ಸ್ಥಾಪಿತ",
    heroCta: "ಸದಸ್ಯರಾಗಿ",
    quickGrievance: "ದೂರು",
    quickPlans: "ಸದಸ್ಯತ್ವ",
    quickAbout: "ನಮ್ಮ ಬಗ್ಗೆ",
    quickContact: "ಸಂಪರ್ಕ",
    unlockTitle: "ಸದಸ್ಯತ್ವ ಪಡೆಯಿರಿ",
    unlockTitlePending: "ಸದಸ್ಯತ್ವ ಪೂರ್ಣಗೊಳಿಸಿ",
    unlockSub: "VHRP ಸೇರಿ ಮತ್ತು ತಕ್ಷಣ ಅಧಿಕೃತ ಡಿಜಿಟಲ್ ಐಡಿ ಕಾರ್ಡ್ ಪಡೆಯಿರಿ.",
    unlockSubPending: "ಬಹುತೇಕ ಮುಗಿದಿದೆ — ಪಾವತಿ ಪೂರ್ಣಗೊಳಿಸಿ ಡಿಜಿಟಲ್ ಐಡಿ ಕಾರ್ಡ್ ಪಡೆಯಿರಿ.",
    founderMsgTitle: "ಸಂಸ್ಥಾಪಕರ ಸಂದೇಶ",
    founderName: "ಶ್ರೀ ಗೋಪಾಲ್ ರಾಯ್",
    founderRole: "ಅಂತರರಾಷ್ಟ್ರೀಯ ಅಧ್ಯಕ್ಷರು (VHRP)",
    founderQuote: "ಸಮಾಜವನ್ನು ಬಲಪಡಿಸುವುದು, ನಮ್ಮ ಸಂಸ್ಕೃತಿಯನ್ನು ರಕ್ಷಿಸುವುದು ಮತ್ತು ಏಕತಾ ಭಾವನೆಯನ್ನು ಬೆಳೆಸುವುದು ನಮ್ಮ ಗುರಿ.",
    galleryTitle: "ಫೋಟೋ ಗ್ಯಾಲರಿ",
    latestUpdates: "ಇತ್ತೀಚಿನ ಸುದ್ದಿ & ಕಾರ್ಯಕ್ರಮಗಳು",
    statPrograms: "ಜಾಗೃತಿ ಕಾರ್ಯಕ್ರಮಗಳು",
    statRelief: "ವಿಪತ್ತು ಪರಿಹಾರ",
    statCenters: "ತರಬೇತಿ ಕೇಂದ್ರಗಳು",
    aboutKicker: "ನಮ್ಮ ಬಗ್ಗೆ",
    aboutTitle: "ವಿಶ್ವ ಹಿಂದೂ\nರಕ್ಷಾ ಪರಿಷತ್",
    aboutHeroSub: "ಸಮಾಜದ ರಕ್ಷಣೆ, ಸಬಲೀಕರಣ ಮತ್ತು ಪ್ರಗತಿಗೆ ಸಮರ್ಪಿತವಾದ ಧಾರ್ಮಿಕ ಮತ್ತು ಸಾಮಾಜಿಕ ಸಂಘಟನೆ.",
    aboutStoryTitle: "ನಮ್ಮ ಕಥೆ",
    aboutStory: "ವಿಶ್ವ ಹಿಂದೂ ರಕ್ಷಾ ಪರಿಷತ್ (VHRP) ರಾಮನವಮಿ ಶುಭ ಸಂದರ್ಭದಲ್ಲಿ ಶ್ರೀ ಗೋಪಾಲ್ ರಾಯ್ ಸ್ಥಾಪಿಸಿದ ಧಾರ್ಮಿಕ ಮತ್ತು ಸಾಮಾಜಿಕ ಸಂಘಟನೆ. ದೇಶಾದ್ಯಂತ ಪ್ರವಾಸದ ವೇಳೆ, ಹಿಂದೂ ಸಮಾಜದ ಅಭಿವೃದ್ಧಿ ನಿರೀಕ್ಷಿತ ಮಟ್ಟದಲ್ಲಿ ಆಗುತ್ತಿಲ್ಲ ಎಂದು ಅವರು ಅರಿತರು. ಈ ಸ್ಥಿತಿಯನ್ನು ಬದಲಾಯಿಸಲು, ಹಿಂದೂ ಧರ್ಮ ಮತ್ತು ಸಮಾಜವನ್ನು ಹೆಚ್ಚು ಬಲಿಷ್ಠ ಮತ್ತು ಸಂಘಟಿತ ರೂಪದಲ್ಲಿ ಮುನ್ನಡೆಸಲು VHRP ಸ್ಥಾಪಿಸಿದರು.",
    objectivesTitle: "ನಮ್ಮ ಮುಖ್ಯ ಉದ್ದೇಶಗಳು",
    obj1: "ಭಾರತವನ್ನು ಹಿಂದೂ ರಾಷ್ಟ್ರವನ್ನಾಗಿ ಮಾಡುವುದು",
    obj2: "ಜಾತೀಯತೆಯನ್ನು ಕೊನೆಗೊಳಿಸುವುದು",
    obj3: "ಬಾಲ್ಯ ವಿವಾಹ ನಿಷೇಧ",
    obj4: "ಬಡ ಮಕ್ಕಳಿಗೆ ಶಿಕ್ಷಣ ನೀಡುವುದು",
    obj5: "ಗೋಹತ್ಯೆ ಕೇಂದ್ರಗಳ ನಿಷೇಧ",
    obj6: "ಆರ್ಥಿಕವಾಗಿ ದುರ್ಬಲ ಕುಟುಂಬಗಳ ಹೆಣ್ಣುಮಕ್ಕಳ ವಿವಾಹಕ್ಕೆ ನೆರವು",
    purposeTitle: "ನಮ್ಮ ಉದ್ದೇಶ",
    purposeBody: "VHRP ಹಿಂದೂ ಧರ್ಮದ ಪರಂಪರೆ, ಸಂಸ್ಕೃತಿ ಮತ್ತು ಮೌಲ್ಯಗಳನ್ನು ರಕ್ಷಿಸುತ್ತದೆ, ಸಂಪ್ರದಾಯಗಳನ್ನು ಸಂರಕ್ಷಿಸುತ್ತದೆ ಮತ್ತು ಸಾಮಾಜಿಕ ಸಮಸ್ಯೆಗಳನ್ನು ಪರಿಹರಿಸಿ ಬಲಿಷ್ಠ ಸಮಾಜವನ್ನು ನಿರ್ಮಿಸುತ್ತದೆ.",
    coreValuesTitle: "ನಮ್ಮ ಮೂಲ ಮೌಲ್ಯಗಳು",
    coreValuesBody: "ಸೇವೆ ಮತ್ತು ಸಂಸ್ಕೃತಿಯ ಮೂಲಕ ಸಮಾಜದ ಏಕತೆಯನ್ನು ಬಲಪಡಿಸುತ್ತೇವೆ. ಸತ್ಯ, ಕರುಣೆ ಮತ್ತು ಸಹನೆಯೊಂದಿಗೆ ಶಾಂತಿಯುತ ಸಹಬಾಳ್ವೆಯಲ್ಲಿ ನಂಬಿಕೆ ಇಡುತ್ತೇವೆ.",
    initiativesTitle: "ಪರಿಣಾಮಕಾರಿ ಉಪಕ್ರಮಗಳು",
    initiativesBody: "\"ಸಂಸ್ಕೃತಿ ರಕ್ಷಾ ಯೋಜನೆ\" ಸಂಪ್ರದಾಯಗಳನ್ನು ಸಂರಕ್ಷಿಸುತ್ತದೆ, \"ಮಕ್ಕಳ ಅಭಿವೃದ್ಧಿ ಕೇಂದ್ರ\" ಯುವಕರನ್ನು ಸಬಲಗೊಳಿಸುತ್ತದೆ, \"ಸೇವಾ ಕೇಂದ್ರ\" ಆರೋಗ್ಯ ಸೇವೆಗಳನ್ನು ನೀಡುತ್ತದೆ.",
    achievementsTitle: "ನಮ್ಮ ಸಾಧನೆಗಳು",
    achievementsBody: "500+ ಜಾಗೃತಿ ಕಾರ್ಯಕ್ರಮಗಳು, 50,000+ ಜನರಿಗೆ ವಿಪತ್ತು ಪರಿಹಾರ, ಯುವಕರಿಗೆ ತರಬೇತಿ ಕೇಂದ್ರಗಳು, ಪ್ರಾಚೀನ ದೇವಾಲಯಗಳ ಸಂರಕ್ಷಣಾ ಅಭಿಯಾನಗಳು.",
    founderSecTitle: "ನಮ್ಮ ಸಂಸ್ಥಾಪಕರು",
    founderDesc: "VHRP ಅಂತರರಾಷ್ಟ್ರೀಯ ಅಧ್ಯಕ್ಷ ಶ್ರೀ ಗೋಪಾಲ್ ರಾಯ್ ನಾಯಕತ್ವ ಮತ್ತು ಸಮಾಜ ಸೇವೆಗೆ ಹೆಸರುವಾಸಿ. ಸಮಾಜವನ್ನು ಸಬಲಗೊಳಿಸುವುದು ಮತ್ತು ಸಂಸ್ಕೃತಿಯನ್ನು ರಕ್ಷಿಸುವುದು ಅವರ ಗುರಿ.",
    joinCta: "VHRP ಸೇರಿ",
    contactTitle: "ಸಂಪರ್ಕಿಸಿ",
    contactIntro: "ಪ್ರಶ್ನೆಗಳಿವೆಯೇ? ಬೆಂಬಲ, ಸದಸ್ಯತ್ವ ಅಥವಾ ಪಾಲುದಾರಿಕೆಗಾಗಿ VHRP ಸಂಪರ್ಕಿಸಿ.",
    contactCallLabel: "ದೂರವಾಣಿ (ಕಚೇರಿ)",
    contactMobileLabel: "ಮೊಬೈಲ್ / ಸಹಾಯವಾಣಿ",
    contactEmailLabel: "ಇಮೇಲ್",
    contactWebsiteLabel: "ವೆಬ್‌ಸೈಟ್",
    contactAddressLabel: "ಪ್ರಧಾನ ಕಚೇರಿ",
    memTitle: "ಸದಸ್ಯತ್ವ ಆರಿಸಿ",
    memSubtitle: "VHRP ಧ್ಯೇಯವನ್ನು ಬೆಂಬಲಿಸಿ. ನಿಮಗೆ ಸೂಕ್ತವಾದ ಹಂತವನ್ನು ಆರಿಸಿ.",
    perYear: "/ ವರ್ಷ",
    memContinue: "ನೋಂದಣಿಗೆ ಮುಂದುವರಿಸಿ",
    memUpgrade: "ಅಪ್‌ಗ್ರೇಡ್ / ನವೀಕರಣ",
    tierSupporter: "ಬೆಂಬಲಿಗ",
    tierFriend: "ಮಿತ್ರ",
    tierAssociate: "ಸಹವರ್ತಿ",
    tierActive: "ಸಕ್ರಿಯ ಸದಸ್ಯ",
    tierPatron: "ಪೋಷಕ",
    tierFounder: "ಸಂಸ್ಥಾಪಕ ವಲಯ",
    ben1: "ಡಿಜಿಟಲ್ ಸದಸ್ಯತ್ವ ಐಡಿ",
    ben2: "1 ವರ್ಷದ ಮಾನ್ಯತೆ",
    ben3: "ಸುದ್ದಿಪತ್ರ ನವೀಕರಣಗಳು",
    ben4: "ಕಾರ್ಯಕ್ರಮ ಆಹ್ವಾನಗಳು",
    ben5: "ಸ್ವಯಂಸೇವಕ ಅವಕಾಶಗಳು",
    ben6: "ಮಿತ್ರ ಹಂತದ ಎಲ್ಲವೂ",
    ben7: "ದೂರಿಗೆ ಆದ್ಯತೆಯ ಪ್ರತಿಕ್ರಿಯೆ",
    ben8: "ಸ್ಥಳೀಯ ಶಾಖೆ ಪ್ರವೇಶ",
    ben9: "ಸಹವರ್ತಿ ಹಂತದ ಎಲ್ಲವೂ",
    ben10: "ರಾಜ್ಯ ಮಟ್ಟದ ಕಾರ್ಯಕ್ರಮಗಳು",
    ben11: "ಮಾನ್ಯತಾ ಪ್ರಮಾಣಪತ್ರ",
    ben12: "ಸಕ್ರಿಯ ಹಂತದ ಎಲ್ಲವೂ",
    ben13: "ರಾಷ್ಟ್ರೀಯ ಸಮಾವೇಶ ಪ್ರವೇಶ",
    ben14: "ನಾಯಕತ್ವದೊಂದಿಗೆ ನೇರ ಸಂಪರ್ಕ",
    ben15: "ಪೋಷಕ ಹಂತದ ಎಲ್ಲವೂ",
    ben16: "ಆಜೀವ ಮಾನ್ಯತೆ",
    ben17: "ವಿಶೇಷ ಸಂಸ್ಥಾಪಕ ಕಾರ್ಯಕ್ರಮಗಳು",
    ben18: "ನಾಯಕತ್ವದ ವೈಯಕ್ತಿಕ ಸ್ವಾಗತ",
    grvTitle: "ದೂರು ದಾಖಲಿಸಿ",
    grvSubtitle: "VHRP ಗೆ ಸಮಸ್ಯೆ ಅಥವಾ ದೂರನ್ನು ವರದಿ ಮಾಡಿ.",
    grvSubject: "ವಿಷಯ *",
    grvSubjectPh: "ಸಂಕ್ಷಿಪ್ತ ಶೀರ್ಷಿಕೆ",
    grvCategory: "ವರ್ಗ",
    grvLocation: "ಸ್ಥಳ (ನಗರ, ರಾಜ್ಯ)",
    grvLocationPh: "ಉದಾ. ಬೆಂಗಳೂರು, ಕರ್ನಾಟಕ",
    grvDesc: "ಸಮಸ್ಯೆಯನ್ನು ವಿವರಿಸಿ *",
    grvDescPh: "ಪೂರ್ಣ ವಿವರ ಹಂಚಿಕೊಳ್ಳಿ — ಏನಾಯಿತು, ಯಾವಾಗ, ಯಾರು ಒಳಗೊಂಡಿದ್ದರು.",
    grvSubmit: "ದೂರು ಸಲ್ಲಿಸಿ",
    grvFillReq: "ದಯವಿಟ್ಟು ವಿಷಯ ಮತ್ತು ವಿವರಣೆ ಭರ್ತಿ ಮಾಡಿ",
    grvOkTitle: "ದೂರು ಸ್ವೀಕರಿಸಲಾಗಿದೆ",
    grvOkSub: "ನಿಮ್ಮ ದೂರು ದಾಖಲಾಗಿದೆ. ನಮ್ಮ ತಂಡ 3 ಕೆಲಸದ ದಿನಗಳಲ್ಲಿ ಸಂಪರ್ಕಿಸುತ್ತದೆ.",
    grvTicket: "ಟಿಕೆಟ್ ಐಡಿ",
    grvAnother: "ಇನ್ನೊಂದು ದೂರು ದಾಖಲಿಸಿ",
    catLand: "ಭೂ ವಿವಾದ",
    catCorruption: "ಭ್ರಷ್ಟಾಚಾರ",
    catPublic: "ಸಾರ್ವಜನಿಕ ಸೇವೆ",
    catWomen: "ಮಹಿಳಾ ಸುರಕ್ಷತೆ",
    catCommunal: "ಕೋಮು ಸಮಸ್ಯೆ",
    catOther: "ಇತರೆ",
    regTitle: "ಸದಸ್ಯತ್ವ ವಿವರಗಳು",
    regTierLabel: "ಹಂತ",
    regPhotoAdd: "ಫೋಟೋ ಸೇರಿಸಿ",
    regPhotoHint: "ಪಾಸ್‌ಪೋರ್ಟ್ ಫೋಟೋ (3:4)\nನಿಮ್ಮ ಡಿಜಿಟಲ್ ಐಡಿ ಕಾರ್ಡ್‌ನಲ್ಲಿ ಬಳಸಲಾಗುತ್ತದೆ.",
    regFullName: "ಪೂರ್ಣ ಹೆಸರು *",
    regFather: "ತಂದೆ / ಪೋಷಕರ ಹೆಸರು *",
    regAddress: "ವಿಳಾಸ *",
    regPhone: "ಫೋನ್ *",
    regDob: "ಜನ್ಮ ದಿನಾಂಕ *",
    regEmail: "ಇಮೇಲ್",
    regDesignation: "ಹುದ್ದೆ",
    regBlood: "ರಕ್ತ ಗುಂಪು",
    regAadhaar: "ಆಧಾರ್ ಸಂಖ್ಯೆ *",
    regPay: "ಪಾವತಿಗೆ ಮುಂದುವರಿಸಿ",
    regFillReq: "ಅಗತ್ಯವಿರುವ ಎಲ್ಲಾ ಕ್ಷೇತ್ರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ",
    regPhotoPerm: "ಫೋಟೋ ಅನುಮತಿ ಅಗತ್ಯವಿದೆ",
    regDefaultDesig: "ಸಾಮಾನ್ಯ ಸದಸ್ಯ",
    payTitle: "ಪಾವತಿ",
    payCreating: "ನಿಮ್ಮ ಆರ್ಡರ್ ರಚಿಸಲಾಗುತ್ತಿದೆ…",
    payAmount: "ಪಾವತಿಸಬೇಕಾದ ಮೊತ್ತ",
    payDemo: "ಡೆಮೊ ಮೋಡ್: Razorpay ಕೀಗಳು ಕಾನ್ಫಿಗರ್ ಆಗಿಲ್ಲ. \"ಪಾವತಿಸಿ\" ಒತ್ತಿದರೆ ಯಶಸ್ವಿ ಪಾವತಿ ಅನುಕರಿಸಲಾಗುತ್ತದೆ.",
    paySimulate: "ಪಾವತಿ ಅನುಕರಿಸಿ",
    payNow: "ಈಗ ಪಾವತಿಸಿ",
    paySecured: "🔒 Razorpay ಮೂಲಕ ಸುರಕ್ಷಿತ",
    payProcessing: "ಪಾವತಿ ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿದೆ…",
    payFailTitle: "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ",
    payFailSub: "ಏನೋ ತಪ್ಪಾಗಿದೆ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    payBack: "ಹಿಂದೆ ಹೋಗಿ",
    payOkTitle: "ನೀವು ಸದಸ್ಯರಾದಿರಿ! 🎉",
    payOkSub: "ಪಾವತಿ ಸ್ವೀಕರಿಸಲಾಗಿದೆ. ನಿಮ್ಮ ಡಿಜಿಟಲ್ ಐಡಿ ಕಾರ್ಡ್ ಸಿದ್ಧವಾಗಿದೆ.",
    payViewCard: "ನನ್ನ ಡಿಜಿಟಲ್ ಕಾರ್ಡ್ ನೋಡಿ",
    cardHeadTitle: "ನನ್ನ ಡಿಜಿಟಲ್ ಐಡಿ",
    cardScan: "ಪರಿಶೀಲಿಸಲು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
    cardScanHint: "ಪರಿಶೀಲಕರು ಈ ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ ನಿಮ್ಮ ಸಕ್ರಿಯ ಸದಸ್ಯತ್ವವನ್ನು ದೃಢೀಕರಿಸಬಹುದು.",
    cardEmptyTitle: "ಸಕ್ರಿಯ ಸದಸ್ಯತ್ವ ಇಲ್ಲ",
    cardEmptySub: "ಡಿಜಿಟಲ್ ಐಡಿ ಕಾರ್ಡ್ ಪಡೆಯಲು ನೋಂದಣಿ ಪೂರ್ಣಗೊಳಿಸಿ.",
    cardGet: "ಸದಸ್ಯತ್ವ ಪಡೆಯಿರಿ",
    dMembershipId: "ಸದಸ್ಯತ್ವ ಐಡಿ",
    dTier: "ಹಂತ",
    dFullName: "ಪೂರ್ಣ ಹೆಸರು",
    dFather: "ತಂದೆಯ ಹೆಸರು",
    dDob: "ಜನ್ಮ ದಿನಾಂಕ",
    dPhone: "ಫೋನ್",
    dAddress: "ವಿಳಾಸ",
    cardShareMsg: "ನಾನು ಈಗ ವಿಶ್ವ ಹಿಂದೂ ರಕ್ಷಾ ಪರಿಷತ್ ಸದಸ್ಯ! ಸದಸ್ಯತ್ವ ಐಡಿ:",
    cardOfficialSub: "ಡಿಜಿಟಲ್ ಸದಸ್ಯತ್ವ ಕಾರ್ಡ್",
    cardValidUntil: "ಮಾನ್ಯತೆ",
    cardSo: "ತಂದೆ",
    cardBlood: "ರಕ್ತ",
    cardCity: "ನಗರ",
    cardState: "ರಾಜ್ಯ",
    profCardSection: "ನನ್ನ ಡಿಜಿಟಲ್ ಕಾರ್ಡ್",
    profBecome: "ಸದಸ್ಯರಾಗಿ",
    profBecomeSub: "ನಿಮಿಷಗಳಲ್ಲಿ ಅಧಿಕೃತ ಡಿಜಿಟಲ್ ಐಡಿ ಕಾರ್ಡ್ ಪಡೆಯಿರಿ.",
    profComplaints: "ನನ್ನ ದೂರುಗಳು",
    profMore: "ಇನ್ನಷ್ಟು",
    profAboutItem: "VHRP ಬಗ್ಗೆ",
    profContactItem: "ಸಂಪರ್ಕಿಸಿ",
    profPrivacy: "ಗೌಪ್ಯತಾ ನೀತಿ",
    profLanguageItem: "ಭಾಷೆ / Language",
    profLogout: "ಲಾಗ್ ಔಟ್",
    newsHeader: "ಸುದ್ದಿ",
    verifyTile: "ಸದಸ್ಯರನ್ನು ಪರಿಶೀಲಿಸಿ",
    verifyTitle: "ಸದಸ್ಯ ಪರಿಶೀಲನೆ",
    verifyIntro: "ಸದಸ್ಯರ QR ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ ತಕ್ಷಣ ಸದಸ್ಯತ್ವವನ್ನು ದೃಢೀಕರಿಸಿ. ಕ್ಯಾಮೆರಾ ಸ್ಕ್ಯಾನಿಂಗ್‌ಗೆ ಮಾತ್ರ ಬಳಸಲಾಗುತ್ತದೆ.",
    verifyEnable: "ಕ್ಯಾಮೆರಾ ಆನ್ ಮಾಡಿ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
    verifyDeniedMsg: "ಕ್ಯಾಮೆರಾ ಅನುಮತಿ ನಿರಾಕರಿಸಲಾಗಿದೆ. ಕೆಳಗೆ ಸದಸ್ಯತ್ವ ಐಡಿ ಟೈಪ್ ಮಾಡಿ, ಅಥವಾ ಸೆಟ್ಟಿಂಗ್‌ಗಳಲ್ಲಿ ಕ್ಯಾಮೆರಾ ಆನ್ ಮಾಡಿ.",
    verifyOpenSettings: "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ತೆರೆಯಿರಿ",
    verifyScanHint: "ಕ್ಯಾಮೆರಾವನ್ನು ಸದಸ್ಯರ QR ಕೋಡ್‌ಗೆ ತೋರಿಸಿ",
    verifyManual: "ಅಥವಾ ಸದಸ್ಯತ್ವ ಐಡಿ ನಮೂದಿಸಿ",
    verifyCheck: "ಪರಿಶೀಲಿಸಿ",
    verifyChecking: "ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ…",
    verifyValid: "ಮಾನ್ಯ ಸದಸ್ಯ",
    verifyExpired: "ಸದಸ್ಯತ್ವ ಅವಧಿ ಮುಗಿದಿದೆ",
    verifyInvalid: "ಅಮಾನ್ಯ ಸದಸ್ಯ",
    verifyNotFound: "ಈ ಐಡಿಯಲ್ಲಿ ಸದಸ್ಯರು ಕಂಡುಬಂದಿಲ್ಲ.",
    verifyScanAgain: "ಇನ್ನೊಂದನ್ನು ಪರಿಶೀಲಿಸಿ",
    verifyWebHint: "ಕ್ಯಾಮೆರಾ ಸ್ಕ್ಯಾನಿಂಗ್ ಮೊಬೈಲ್ ಆ್ಯಪ್‌ನಲ್ಲಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ. ಕೆಳಗೆ ಸದಸ್ಯತ್ವ ಐಡಿ ನಮೂದಿಸಿ.",
    cardSave: "ಚಿತ್ರ ಉಳಿಸಿ",
    cardShare: "ಹಂಚಿಕೊಳ್ಳಿ",
    cardSaved: "ಕಾರ್ಡ್ ಚಿತ್ರ ಗ್ಯಾಲರಿಯಲ್ಲಿ ಉಳಿಸಲಾಗಿದೆ",
    cardSaveFailed: "ಕಾರ್ಡ್ ಉಳಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ",
    cardPermPhotos: "ಕಾರ್ಡ್ ಅನ್ನು ಗ್ಯಾಲರಿಯಲ್ಲಿ ಉಳಿಸಲು ಫೋಟೋ ಅನುಮತಿ ನೀಡಿ",
    trackTitle: "ದೂರಿನ ಸ್ಥಿತಿ",
    stReceived: "ಸ್ವೀಕರಿಸಲಾಗಿದೆ",
    stInReview: "ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ",
    stResolved: "ಪರಿಹರಿಸಲಾಗಿದೆ",
    trackDesc: "ವಿವರಣೆ",
    trackLocation: "ಸ್ಥಳ",
    eventsTitle: "ಮುಂಬರುವ ಕಾರ್ಯಕ್ರಮಗಳು",
    eventsEmpty: "ಸದ್ಯ ಮುಂಬರುವ ಕಾರ್ಯಕ್ರಮಗಳಿಲ್ಲ. ಶೀಘ್ರದಲ್ಲೇ ನೋಡಿ!",
    rsvpGo: "ನಾನು ಹಾಜರಾಗುತ್ತೇನೆ",
    rsvpGoing: "ನೀವು ಹೋಗುತ್ತಿದ್ದೀರಿ ✓",
    attending: "ಹಾಜರಾಗುತ್ತಿದ್ದಾರೆ",
    seeAll: "ಎಲ್ಲವನ್ನೂ ನೋಡಿ",
    renewSoonTitle: "ಸದಸ್ಯತ್ವ ಶೀಘ್ರದಲ್ಲೇ ಮುಗಿಯಲಿದೆ",
    renewSoonBody: "ನಿಮ್ಮ ಸದಸ್ಯತ್ವ {days} ದಿನಗಳಲ್ಲಿ ಮುಗಿಯಲಿದೆ. ಡಿಜಿಟಲ್ ಐಡಿ ಸಕ್ರಿಯವಾಗಿರಿಸಲು ನವೀಕರಿಸಿ.",
    renewExpiredTitle: "ಸದಸ್ಯತ್ವ ಮುಗಿದಿದೆ",
    renewExpiredBody: "ನಿಮ್ಮ ಸದಸ್ಯತ್ವ ಮುಗಿದಿದೆ. ಡಿಜಿಟಲ್ ಐಡಿ ಮರುಸಕ್ರಿಯಗೊಳಿಸಲು ಈಗಲೇ ನವೀಕರಿಸಿ.",
    renewCta: "ಈಗ ನವೀಕರಿಸಿ",
    evToday: "ಇಂದು ಇದೆ!",
    evTomorrow: "ನಾಳೆ ಇದೆ!",
    regCity: "ನಗರ *",
    regState: "ರಾಜ್ಯ *",
    regCountry: "ದೇಶ",
    regSocial: "ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ ಲಿಂಕ್",
    regSocialPh: "ಉದಾ. https://facebook.com/yourprofile",
    regAadhaarInvalid: "ಮಾನ್ಯ 12-ಅಂಕಿಯ ಆಧಾರ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    otpSend: "OTP ಕಳುಹಿಸಿ",
    otpSent: "ನಿಮ್ಮ ಸಂಖ್ಯೆಗೆ OTP ಕಳುಹಿಸಲಾಗಿದೆ",
    otpEnterPh: "6-ಅಂಕಿಯ OTP",
    otpVerify: "ಪರಿಶೀಲಿಸಿ",
    otpVerified: "ಪರಿಶೀಲಿಸಲಾಗಿದೆ ✓",
    otpDemoNote: "ಡೆಮೊ ಮೋಡ್ — ನಿಮ್ಮ OTP:",
    otpRequired: "ಮೊದಲು OTP ಮೂಲಕ ಫೋನ್ ಸಂಖ್ಯೆ ಪರಿಶೀಲಿಸಿ",
    dirTile: "ಸದಸ್ಯರ ಡೈರೆಕ್ಟರಿ",
    dirTotalLabel: "ನೋಂದಾಯಿತ ಸದಸ್ಯರು",
    dirSearchPh: "ಹೆಸರು, ನಗರ ಅಥವಾ ರಾಜ್ಯ ಹುಡುಕಿ…",
    dirAll: "ಎಲ್ಲಾ",
    dirIndia: "ಭಾರತ",
    dirIntl: "ಅಂತಾರಾಷ್ಟ್ರೀಯ",
    dirLockedTitle: "ಸದಸ್ಯರಿಗೆ ಮಾತ್ರ",
    dirLockedSub: "ಸದಸ್ಯರ ಡೈರೆಕ್ಟರಿ ಸಕ್ರಿಯ ಸದಸ್ಯರಿಗೆ ಮಾತ್ರ ಲಭ್ಯ. ಭಾರತ ಮತ್ತು ವಿದೇಶದ VHRP ಸದಸ್ಯರೊಂದಿಗೆ ಸಂಪರ್ಕ ಸಾಧಿಸಲು ಸದಸ್ಯತ್ವ ಪಡೆಯಿರಿ.",
    dirEmpty: "ಸದಸ್ಯರು ಸಿಗಲಿಲ್ಲ",
    grvPhotos: "ಪುರಾವೆಯಾಗಿ ಫೋಟೋ ಲಗತ್ತಿಸಿ (ಐಚ್ಛಿಕ, ಗರಿಷ್ಠ 3)",
    trackPhotos: "ಲಗತ್ತಿಸಿದ ಫೋಟೋಗಳು",
  },
  bn: {
    orgName: "বিশ্ব হিন্দু রক্ষা পরিষদ",
    motto: "যতো ধর্মঃ ততো জয়ঃ",
    back: "পিছনে",
    loadError: "ডেটা লোড করা যায়নি। আপনার সংযোগ পরীক্ষা করুন।",
    retry: "আবার চেষ্টা করুন",
    newBadge: "নতুন",
    videosTitle: "ভিডিও",
    videosEmpty: "কোনো ভিডিও নেই — আমাদের YouTube চ্যানেল দেখুন",
    desigMember: "সদস্য",
    desigGeneral: "সাধারণ সদস্য",
    contactHQ: "অন্যান্য দায়িত্বশীল সদস্যপদের জন্য প্রধান কার্যালয়ে যোগাযোগ করুন",
    promoTill: "শুধুমাত্র ৪ অক্টোবর পর্যন্ত",
    inviteCopied: "আমন্ত্রণ কপি হয়েছে — WhatsApp-এ পেস্ট করুন",
    share: "শেয়ার করুন",
    copied: "ক্লিপবোর্ডে কপি হয়েছে",
    photoVerifying: "AI আপনার ছবি যাচাই করছে…",
    photoRejected: "ছবি প্রত্যাখ্যাত",
    aadhaarFront: "আধার সামনের ছবি *",
    aadhaarBack: "আধার পিছনের ছবি *",
    aadhaarPhotosReq: "আধারের সামনে ও পিছনের ছবি বাধ্যতামূলক",
    aadhaarAdminOnly: "শুধুমাত্র VHRP অ্যাডমিনরা দেখতে পাবেন",
    tabHome: "হোম",
    tabMembership: "সদস্যপদ",
    tabGrievance: "অভিযোগ",
    tabProfile: "প্রোফাইল",
    langTitle: "আপনার ভাষা নির্বাচন করুন",
    langSubtitle: "আপনার সবচেয়ে স্বাচ্ছন্দ্যের ভাষাটি বেছে নিন",
    langContinue: "চালিয়ে যান",
    loginTagline: "সদস্যপদ • অভিযোগ • সেবা",
    loginGoogle: "Google দিয়ে চালিয়ে যান",
    loginLegal: "চালিয়ে গেলে আপনি VHRP-এর শর্তাবলী\nও গোপনীয়তা নীতিতে সম্মত হন।",
    greet: "নমস্তে 🙏",
    defaultMember: "সদস্য",
    heroTitle: "সমাজের সুরক্ষা, ক্ষমতায়ন ও অগ্রগতি",
    heroSub: "রামনবমীর শুভ দিনে শ্রী গোপাল রায় কর্তৃক প্রতিষ্ঠিত",
    heroCta: "সদস্য হোন",
    quickGrievance: "অভিযোগ",
    quickPlans: "সদস্যপদ",
    quickAbout: "আমাদের সম্পর্কে",
    quickContact: "যোগাযোগ",
    unlockTitle: "সদস্যপদ নিন",
    unlockTitlePending: "সদস্যপদ সম্পূর্ণ করুন",
    unlockSub: "VHRP-এ যোগ দিন এবং সাথে সাথে আপনার অফিসিয়াল ডিজিটাল আইডি কার্ড পান।",
    unlockSubPending: "প্রায় শেষ — পেমেন্ট সম্পূর্ণ করে ডিজিটাল আইডি কার্ড পান।",
    founderMsgTitle: "প্রতিষ্ঠাতার বার্তা",
    founderName: "শ্রী গোপাল রায়",
    founderRole: "আন্তর্জাতিক সভাপতি (VHRP)",
    founderQuote: "সমাজকে শক্তিশালী করা, আমাদের সংস্কৃতি রক্ষা করা এবং ঐক্যের অনুভূতি জাগানোই আমাদের লক্ষ্য।",
    galleryTitle: "ফটো গ্যালারি",
    latestUpdates: "সর্বশেষ খবর ও অনুষ্ঠান",
    statPrograms: "সচেতনতা কর্মসূচি",
    statRelief: "দুর্যোগ ত্রাণ প্রদান",
    statCenters: "প্রশিক্ষণ কেন্দ্র",
    aboutKicker: "আমাদের সম্পর্কে",
    aboutTitle: "বিশ্ব হিন্দু\nরক্ষা পরিষদ",
    aboutHeroSub: "সমাজের সুরক্ষা, ক্ষমতায়ন ও অগ্রগতিতে নিবেদিত একটি ধর্মীয় ও সামাজিক সংগঠন।",
    aboutStoryTitle: "আমাদের গল্প",
    aboutStory: "বিশ্ব হিন্দু রক্ষা পরিষদ (VHRP) রামনবমীর শুভ দিনে শ্রী গোপাল রায় কর্তৃক প্রতিষ্ঠিত একটি ধর্মীয় ও সামাজিক সংগঠন। দেশজুড়ে ভ্রমণের সময় তিনি উপলব্ধি করেন যে হিন্দু সমাজের উন্নয়ন প্রত্যাশিত গতিতে হচ্ছে না। এই অবস্থা পরিবর্তনের জন্য, হিন্দু ধর্ম ও সমাজকে আরও শক্তিশালী ও সংগঠিত রূপে উপস্থাপন করতে তিনি VHRP প্রতিষ্ঠা করেন।",
    objectivesTitle: "আমাদের প্রধান উদ্দেশ্য",
    obj1: "ভারতকে হিন্দু রাষ্ট্র করা",
    obj2: "জাতিভেদ প্রথার অবসান",
    obj3: "বাল্যবিবাহ নিষিদ্ধকরণ",
    obj4: "দরিদ্র শিশুদের শিক্ষা প্রদান",
    obj5: "গো-হত্যা কেন্দ্র নিষিদ্ধকরণ",
    obj6: "আর্থিকভাবে দুর্বল পরিবারের মেয়েদের বিবাহে সহায়তা",
    purposeTitle: "আমাদের উদ্দেশ্য",
    purposeBody: "VHRP হিন্দু ধর্মের ঐতিহ্য, সংস্কৃতি ও মূল্যবোধ রক্ষা করে, ঐতিহ্য সংরক্ষণ করে এবং সামাজিক সমস্যা সমাধান করে একটি শক্তিশালী সমাজ গড়ে তোলে।",
    coreValuesTitle: "আমাদের মূল মূল্যবোধ",
    coreValuesBody: "সেবা ও সংস্কৃতির মাধ্যমে আমরা সমাজের ঐক্যকে শক্তিশালী করি। সত্য, করুণা ও সহনশীলতার সাথে শান্তিপূর্ণ সহাবস্থানে বিশ্বাস করি।",
    initiativesTitle: "প্রভাবশালী উদ্যোগ",
    initiativesBody: "\"সংস্কৃতি রক্ষা যোজনা\" ঐতিহ্য সংরক্ষণ করে, \"শিশু বিকাশ কেন্দ্র\" যুবদের ক্ষমতায়ন করে, \"সেবা কেন্দ্র\" স্বাস্থ্য পরিষেবা দেয়।",
    achievementsTitle: "আমাদের অর্জন",
    achievementsBody: "৫০০+ সচেতনতা কর্মসূচি, ৫০,০০০+ মানুষকে দুর্যোগ ত্রাণ, যুবদের জন্য প্রশিক্ষণ কেন্দ্র এবং প্রাচীন মন্দির সংরক্ষণ অভিযান।",
    founderSecTitle: "আমাদের প্রতিষ্ঠাতা",
    founderDesc: "VHRP-এর আন্তর্জাতিক সভাপতি শ্রী গোপাল রায় তাঁর নেতৃত্ব ও সমাজের প্রতি নিষ্ঠার জন্য প্রসিদ্ধ। সমাজকে ক্ষমতায়ন ও সংস্কৃতি রক্ষাই তাঁর লক্ষ্য।",
    joinCta: "VHRP-এ যোগ দিন",
    contactTitle: "যোগাযোগ করুন",
    contactIntro: "কোনো প্রশ্ন আছে? সহায়তা, সদস্যপদ বা অংশীদারিত্বের জন্য VHRP-এর সাথে যোগাযোগ করুন।",
    contactCallLabel: "ফোন (অফিস)",
    contactMobileLabel: "মোবাইল / হেল্পলাইন",
    contactEmailLabel: "ইমেইল",
    contactWebsiteLabel: "ওয়েবসাইট",
    contactAddressLabel: "প্রধান কার্যালয়",
    memTitle: "সদস্যপদ নির্বাচন করুন",
    memSubtitle: "VHRP-এর লক্ষ্যকে সমর্থন করুন। আপনার উপযুক্ত স্তর বেছে নিন।",
    perYear: "/ বছর",
    memContinue: "নিবন্ধনে এগিয়ে যান",
    memUpgrade: "আপগ্রেড / নবায়ন",
    tierSupporter: "সমর্থক",
    tierFriend: "বন্ধু",
    tierAssociate: "সহযোগী",
    tierActive: "সক্রিয় সদস্য",
    tierPatron: "পৃষ্ঠপোষক",
    tierFounder: "প্রতিষ্ঠাতা মণ্ডল",
    ben1: "ডিজিটাল সদস্যপদ আইডি",
    ben2: "১ বছরের মেয়াদ",
    ben3: "নিউজলেটার আপডেট",
    ben4: "অনুষ্ঠানের আমন্ত্রণ",
    ben5: "স্বেচ্ছাসেবার সুযোগ",
    ben6: "বন্ধু স্তরের সবকিছু",
    ben7: "অভিযোগে অগ্রাধিকার সাড়া",
    ben8: "স্থানীয় শাখায় প্রবেশাধিকার",
    ben9: "সহযোগী স্তরের সবকিছু",
    ben10: "রাজ্য স্তরের অনুষ্ঠান",
    ben11: "স্বীকৃতি সনদ",
    ben12: "সক্রিয় স্তরের সবকিছু",
    ben13: "জাতীয় সম্মেলনে প্রবেশাধিকার",
    ben14: "নেতৃত্বের সাথে সরাসরি যোগাযোগ",
    ben15: "পৃষ্ঠপোষক স্তরের সবকিছু",
    ben16: "আজীবন স্বীকৃতি",
    ben17: "বিশেষ প্রতিষ্ঠাতা অনুষ্ঠান",
    ben18: "নেতৃত্বের ব্যক্তিগত অভ্যর্থনা",
    grvTitle: "অভিযোগ দায়ের করুন",
    grvSubtitle: "VHRP-কে কোনো সমস্যা বা অভিযোগ জানান।",
    grvSubject: "বিষয় *",
    grvSubjectPh: "সংক্ষিপ্ত শিরোনাম",
    grvCategory: "বিভাগ",
    grvLocation: "স্থান (শহর, রাজ্য)",
    grvLocationPh: "যেমন কলকাতা, পশ্চিমবঙ্গ",
    grvDesc: "সমস্যাটি বর্ণনা করুন *",
    grvDescPh: "সম্পূর্ণ বিবরণ দিন — কী হয়েছিল, কখন এবং কারা জড়িত ছিল।",
    grvSubmit: "অভিযোগ জমা দিন",
    grvFillReq: "অনুগ্রহ করে বিষয় ও বিবরণ পূরণ করুন",
    grvOkTitle: "অভিযোগ গৃহীত হয়েছে",
    grvOkSub: "আপনার অভিযোগ নথিভুক্ত হয়েছে। আমাদের দল ৩ কর্মদিবসের মধ্যে যোগাযোগ করবে।",
    grvTicket: "টিকিট আইডি",
    grvAnother: "আরেকটি অভিযোগ দায়ের করুন",
    catLand: "জমি বিরোধ",
    catCorruption: "দুর্নীতি",
    catPublic: "জনসেবা",
    catWomen: "নারী নিরাপত্তা",
    catCommunal: "সাম্প্রদায়িক সমস্যা",
    catOther: "অন্যান্য",
    regTitle: "সদস্যপদের বিবরণ",
    regTierLabel: "স্তর",
    regPhotoAdd: "ছবি যোগ করুন",
    regPhotoHint: "পাসপোর্ট ছবি (৩:৪)\nআপনার ডিজিটাল আইডি কার্ডে ব্যবহৃত হবে।",
    regFullName: "পুরো নাম *",
    regFather: "পিতা / অভিভাবকের নাম *",
    regAddress: "ঠিকানা *",
    regPhone: "ফোন *",
    regDob: "জন্ম তারিখ *",
    regEmail: "ইমেইল",
    regDesignation: "পদবি",
    regBlood: "রক্তের গ্রুপ",
    regAadhaar: "আধার নম্বর *",
    regPay: "পেমেন্টে এগিয়ে যান",
    regFillReq: "সমস্ত প্রয়োজনীয় ঘর পূরণ করুন",
    regPhotoPerm: "ছবির অনুমতি প্রয়োজন",
    regDefaultDesig: "সাধারণ সদস্য",
    payTitle: "পেমেন্ট",
    payCreating: "আপনার অর্ডার তৈরি হচ্ছে…",
    payAmount: "প্রদেয় পরিমাণ",
    payDemo: "ডেমো মোড: Razorpay কী কনফিগার করা নেই। \"পেমেন্ট\" চাপলে সফল পেমেন্ট সিমুলেট হবে।",
    paySimulate: "পেমেন্ট সিমুলেট করুন",
    payNow: "এখনই পেমেন্ট করুন",
    paySecured: "🔒 Razorpay দ্বারা সুরক্ষিত",
    payProcessing: "পেমেন্ট প্রক্রিয়াধীন…",
    payFailTitle: "পেমেন্ট ব্যর্থ",
    payFailSub: "কিছু ভুল হয়েছে। আবার চেষ্টা করুন।",
    payBack: "ফিরে যান",
    payOkTitle: "আপনি সদস্য হয়েছেন! 🎉",
    payOkSub: "পেমেন্ট গৃহীত। আপনার ডিজিটাল আইডি কার্ড প্রস্তুত।",
    payViewCard: "আমার ডিজিটাল কার্ড দেখুন",
    cardHeadTitle: "আমার ডিজিটাল আইডি",
    cardScan: "যাচাই করতে স্ক্যান করুন",
    cardScanHint: "যাচাইকারীরা এই কোড স্ক্যান করে আপনার সক্রিয় সদস্যপদ নিশ্চিত করতে পারেন।",
    cardEmptyTitle: "কোনো সক্রিয় সদস্যপদ নেই",
    cardEmptySub: "ডিজিটাল আইডি কার্ড পেতে নিবন্ধন সম্পূর্ণ করুন।",
    cardGet: "সদস্যপদ নিন",
    dMembershipId: "সদস্যপদ আইডি",
    dTier: "স্তর",
    dFullName: "পুরো নাম",
    dFather: "পিতার নাম",
    dDob: "জন্ম তারিখ",
    dPhone: "ফোন",
    dAddress: "ঠিকানা",
    cardShareMsg: "আমি এখন বিশ্ব হিন্দু রক্ষা পরিষদের সদস্য! সদস্যপদ আইডি:",
    cardOfficialSub: "ডিজিটাল সদস্যপদ কার্ড",
    cardValidUntil: "মেয়াদ",
    cardSo: "পিতা",
    cardBlood: "রক্ত",
    cardCity: "শহর",
    cardState: "রাজ্য",
    profCardSection: "আমার ডিজিটাল কার্ড",
    profBecome: "সদস্য হোন",
    profBecomeSub: "মিনিটের মধ্যে অফিসিয়াল ডিজিটাল আইডি কার্ড পান।",
    profComplaints: "আমার অভিযোগসমূহ",
    profMore: "আরও",
    profAboutItem: "VHRP সম্পর্কে",
    profContactItem: "যোগাযোগ করুন",
    profPrivacy: "গোপনীয়তা নীতি",
    profLanguageItem: "ভাষা / Language",
    profLogout: "লগ আউট",
    newsHeader: "খবর",
    verifyTile: "সদস্য যাচাই করুন",
    verifyTitle: "সদস্য যাচাইকরণ",
    verifyIntro: "সদস্যের QR কোড স্ক্যান করে সাথে সাথে সদস্যপদ নিশ্চিত করুন। ক্যামেরা শুধুমাত্র স্ক্যানিংয়ের জন্য ব্যবহৃত হয়।",
    verifyEnable: "ক্যামেরা চালু করে স্ক্যান করুন",
    verifyDeniedMsg: "ক্যামেরার অনুমতি প্রত্যাখ্যাত। নিচে সদস্যপদ আইডি লিখুন, বা সেটিংসে ক্যামেরা চালু করুন।",
    verifyOpenSettings: "সেটিংস খুলুন",
    verifyScanHint: "ক্যামেরাটি সদস্যের QR কোডে ধরুন",
    verifyManual: "অথবা সদস্যপদ আইডি লিখুন",
    verifyCheck: "যাচাই করুন",
    verifyChecking: "যাচাই হচ্ছে…",
    verifyValid: "বৈধ সদস্য",
    verifyExpired: "সদস্যপদের মেয়াদ শেষ",
    verifyInvalid: "অবৈধ সদস্য",
    verifyNotFound: "এই আইডিতে কোনো সদস্য পাওয়া যায়নি।",
    verifyScanAgain: "আরেকটি যাচাই করুন",
    verifyWebHint: "ক্যামেরা স্ক্যানিং মোবাইল অ্যাপে কাজ করে। নিচে সদস্যপদ আইডি লিখুন।",
    cardSave: "ছবি সংরক্ষণ করুন",
    cardShare: "শেয়ার করুন",
    cardSaved: "কার্ডের ছবি গ্যালারিতে সংরক্ষিত হয়েছে",
    cardSaveFailed: "কার্ড সংরক্ষণ করা যায়নি",
    cardPermPhotos: "কার্ড গ্যালারিতে সংরক্ষণ করতে ছবির অনুমতি দিন",
    trackTitle: "অভিযোগের অবস্থা",
    stReceived: "গৃহীত",
    stInReview: "পর্যালোচনায়",
    stResolved: "সমাধান হয়েছে",
    trackDesc: "বিবরণ",
    trackLocation: "স্থান",
    eventsTitle: "আসন্ন অনুষ্ঠান",
    eventsEmpty: "এখন কোনো আসন্ন অনুষ্ঠান নেই। শীঘ্রই দেখুন!",
    rsvpGo: "আমি উপস্থিত থাকব",
    rsvpGoing: "আপনি যাচ্ছেন ✓",
    attending: "উপস্থিত থাকবেন",
    seeAll: "সব দেখুন",
    renewSoonTitle: "সদস্যপদ শীঘ্রই শেষ হবে",
    renewSoonBody: "আপনার সদস্যপদ {days} দিনের মধ্যে শেষ হবে। ডিজিটাল আইডি সক্রিয় রাখতে নবায়ন করুন।",
    renewExpiredTitle: "সদস্যপদ শেষ হয়েছে",
    renewExpiredBody: "আপনার সদস্যপদ শেষ হয়ে গেছে। ডিজিটাল আইডি পুনরায় সক্রিয় করতে এখনই নবায়ন করুন।",
    renewCta: "এখনই নবায়ন করুন",
    evToday: "আজ!",
    evTomorrow: "আগামীকাল!",
    regCity: "শহর *",
    regState: "রাজ্য *",
    regCountry: "দেশ",
    regSocial: "সোশ্যাল মিডিয়া লিঙ্ক",
    regSocialPh: "যেমন https://facebook.com/yourprofile",
    regAadhaarInvalid: "বৈধ ১২-সংখ্যার আধার নম্বর লিখুন",
    otpSend: "OTP পাঠান",
    otpSent: "আপনার নম্বরে OTP পাঠানো হয়েছে",
    otpEnterPh: "৬-সংখ্যার OTP",
    otpVerify: "যাচাই করুন",
    otpVerified: "যাচাইকৃত ✓",
    otpDemoNote: "ডেমো মোড — আপনার OTP:",
    otpRequired: "প্রথমে OTP দিয়ে ফোন নম্বর যাচাই করুন",
    dirTile: "সদস্য ডিরেক্টরি",
    dirTotalLabel: "নিবন্ধিত সদস্য",
    dirSearchPh: "নাম, শহর বা রাজ্য খুঁজুন…",
    dirAll: "সব",
    dirIndia: "ভারত",
    dirIntl: "আন্তর্জাতিক",
    dirLockedTitle: "শুধুমাত্র সদস্যদের জন্য",
    dirLockedSub: "সদস্য ডিরেক্টরি শুধুমাত্র সক্রিয় সদস্যদের জন্য। ভারত ও বিদেশের VHRP সদস্যদের সাথে যুক্ত হতে সদস্যপদ নিন।",
    dirEmpty: "কোনো সদস্য পাওয়া যায়নি",
    grvPhotos: "প্রমাণ হিসেবে ছবি সংযুক্ত করুন (ঐচ্ছিক, সর্বোচ্চ ৩)",
    trackPhotos: "সংযুক্ত ছবি",
  },
  mr: {
    orgName: "विश्व हिंदू रक्षा परिषद",
    motto: "यतो धर्मः ततो जयः",
    back: "मागे",
    loadError: "डेटा लोड होऊ शकला नाही. कृपया तुमचे कनेक्शन तपासा.",
    retry: "पुन्हा प्रयत्न करा",
    newBadge: "नवीन",
    videosTitle: "व्हिडिओ",
    videosEmpty: "अजून व्हिडिओ नाहीत — आमचे YouTube चॅनेल पहा",
    desigMember: "सदस्य",
    desigGeneral: "सामान्य सदस्य",
    contactHQ: "इतर जबाबदार सदस्यत्वासाठी कृपया मुख्य कार्यालयाशी संपर्क साधा",
    promoTill: "फक्त ४ ऑक्टोबरपर्यंत",
    inviteCopied: "निमंत्रण कॉपी झाले — WhatsApp मध्ये पेस्ट करा",
    share: "शेअर करा",
    copied: "क्लिपबोर्डवर कॉपी झाले",
    photoVerifying: "AI तुमचा फोटो पडताळत आहे…",
    photoRejected: "फोटो नाकारला",
    aadhaarFront: "आधार समोरचा फोटो *",
    aadhaarBack: "आधार मागचा फोटो *",
    aadhaarPhotosReq: "आधारचे पुढील व मागील फोटो अनिवार्य आहेत",
    aadhaarAdminOnly: "फक्त VHRP अ‍ॅडमिनना दिसेल",
    tabHome: "होम",
    tabMembership: "सदस्यत्व",
    tabGrievance: "तक्रार",
    tabProfile: "प्रोफाइल",
    langTitle: "तुमची भाषा निवडा",
    langSubtitle: "तुम्हाला सर्वात सोयीची भाषा निवडा",
    langContinue: "पुढे चला",
    loginTagline: "सदस्यत्व • तक्रार • सेवा",
    loginGoogle: "Google सह पुढे चला",
    loginLegal: "पुढे गेल्यास तुम्ही VHRP च्या अटी\nआणि गोपनीयता धोरणास सहमती देता.",
    greet: "नमस्ते 🙏",
    defaultMember: "सदस्य",
    heroTitle: "समाजाचे संरक्षण, सक्षमीकरण आणि प्रगती",
    heroSub: "रामनवमीच्या शुभ मुहूर्तावर श्री गोपाल राय यांनी स्थापन केले",
    heroCta: "सदस्य व्हा",
    quickGrievance: "तक्रार",
    quickPlans: "सदस्यत्व",
    quickAbout: "आमच्याबद्दल",
    quickContact: "संपर्क",
    unlockTitle: "सदस्यत्व मिळवा",
    unlockTitlePending: "सदस्यत्व पूर्ण करा",
    unlockSub: "VHRP मध्ये सामील व्हा आणि लगेच अधिकृत डिजिटल ओळखपत्र मिळवा.",
    unlockSubPending: "जवळजवळ झाले — पेमेंट पूर्ण करा आणि डिजिटल ओळखपत्र मिळवा.",
    founderMsgTitle: "संस्थापकांचा संदेश",
    founderName: "श्री गोपाल राय",
    founderRole: "आंतरराष्ट्रीय अध्यक्ष (VHRP)",
    founderQuote: "समाजाला सक्षम बनवणे, आपल्या संस्कृतीचे रक्षण करणे आणि एकतेची भावना वाढवणे हे आमचे ध्येय आहे.",
    galleryTitle: "फोटो गॅलरी",
    latestUpdates: "ताज्या बातम्या आणि कार्यक्रम",
    statPrograms: "जागरूकता कार्यक्रम",
    statRelief: "आपत्ती मदत",
    statCenters: "प्रशिक्षण केंद्रे",
    aboutKicker: "आमच्याबद्दल",
    aboutTitle: "विश्व हिंदू\nरक्षा परिषद",
    aboutHeroSub: "समाजाच्या संरक्षण, सक्षमीकरण आणि प्रगतीसाठी समर्पित धार्मिक आणि सामाजिक संघटना.",
    aboutStoryTitle: "आमची कहाणी",
    aboutStory: "विश्व हिंदू रक्षा परिषद (VHRP) ही रामनवमीच्या शुभ मुहूर्तावर श्री गोपाल राय यांनी स्थापन केलेली धार्मिक आणि सामाजिक संघटना आहे. देशभरातील प्रवासादरम्यान, हिंदू समाजाचा विकास अपेक्षित गतीने होत नाही हे त्यांच्या लक्षात आले. ही परिस्थिती बदलण्यासाठी, हिंदू धर्म आणि समाजाला अधिक बलशाली आणि संघटित स्वरूपात मांडण्यासाठी त्यांनी VHRP ची स्थापना केली.",
    objectivesTitle: "आमची मुख्य उद्दिष्टे",
    obj1: "भारताला हिंदू राष्ट्र बनवणे",
    obj2: "जातीयवाद संपवणे",
    obj3: "बालविवाहावर बंदी",
    obj4: "गरीब मुलांना शिक्षण देणे",
    obj5: "गोहत्या केंद्रांवर बंदी",
    obj6: "आर्थिकदृष्ट्या दुर्बल कुटुंबातील मुलींच्या विवाहासाठी मदत",
    purposeTitle: "आमचे उद्दिष्ट",
    purposeBody: "VHRP हिंदू धर्माचा वारसा, संस्कृती आणि मूल्यांचे रक्षण करते, परंपरा जपते आणि सामाजिक समस्या सोडवून बलशाली समाज घडवते.",
    coreValuesTitle: "आमची मूलभूत मूल्ये",
    coreValuesBody: "सेवा आणि संस्कृतीच्या माध्यमातून आम्ही समाजाची एकता बळकट करतो. सत्य, करुणा आणि सहिष्णुतेसह शांततापूर्ण सहजीवनावर विश्वास ठेवतो.",
    initiativesTitle: "प्रभावी उपक्रम",
    initiativesBody: "\"संस्कृती रक्षा योजना\" परंपरा जपते, \"बाल विकास केंद्र\" तरुणांना सक्षम करते, \"सेवा केंद्र\" आरोग्य सेवा देते.",
    achievementsTitle: "आमची कामगिरी",
    achievementsBody: "500+ जागरूकता कार्यक्रम, 50,000+ लोकांना आपत्ती मदत, तरुणांसाठी प्रशिक्षण केंद्रे आणि प्राचीन मंदिरांच्या संरक्षणाच्या मोहिमा.",
    founderSecTitle: "आमचे संस्थापक",
    founderDesc: "VHRP चे आंतरराष्ट्रीय अध्यक्ष श्री गोपाल राय हे नेतृत्व आणि समाजसेवेसाठी प्रसिद्ध आहेत. समाजाला सक्षम करणे आणि संस्कृतीचे रक्षण करणे हे त्यांचे ध्येय आहे.",
    joinCta: "VHRP मध्ये सामील व्हा",
    contactTitle: "संपर्क साधा",
    contactIntro: "प्रश्न आहेत? मदत, सदस्यत्व किंवा भागीदारीसाठी VHRP शी संपर्क साधा.",
    contactCallLabel: "फोन (कार्यालय)",
    contactMobileLabel: "मोबाईल / हेल्पलाइन",
    contactEmailLabel: "ईमेल",
    contactWebsiteLabel: "वेबसाइट",
    contactAddressLabel: "मुख्य कार्यालय",
    memTitle: "सदस्यत्व निवडा",
    memSubtitle: "VHRP च्या ध्येयाला पाठिंबा द्या. तुम्हाला योग्य स्तर निवडा.",
    perYear: "/ वर्ष",
    memContinue: "नोंदणीकडे पुढे चला",
    memUpgrade: "अपग्रेड / नूतनीकरण",
    tierSupporter: "समर्थक",
    tierFriend: "मित्र",
    tierAssociate: "सहयोगी",
    tierActive: "सक्रिय सदस्य",
    tierPatron: "आश्रयदाता",
    tierFounder: "संस्थापक मंडळ",
    ben1: "डिजिटल सदस्यत्व ओळखपत्र",
    ben2: "1 वर्षाची वैधता",
    ben3: "वृत्तपत्र अपडेट्स",
    ben4: "कार्यक्रम निमंत्रणे",
    ben5: "स्वयंसेवक संधी",
    ben6: "मित्र स्तरातील सर्वकाही",
    ben7: "तक्रारीला प्राधान्य प्रतिसाद",
    ben8: "स्थानिक शाखा प्रवेश",
    ben9: "सहयोगी स्तरातील सर्वकाही",
    ben10: "राज्यस्तरीय कार्यक्रम",
    ben11: "मान्यता प्रमाणपत्र",
    ben12: "सक्रिय स्तरातील सर्वकाही",
    ben13: "राष्ट्रीय संमेलन प्रवेश",
    ben14: "नेतृत्वाशी थेट संपर्क",
    ben15: "आश्रयदाता स्तरातील सर्वकाही",
    ben16: "आजीवन मान्यता",
    ben17: "विशेष संस्थापक कार्यक्रम",
    ben18: "नेतृत्वाकडून वैयक्तिक स्वागत",
    grvTitle: "तक्रार नोंदवा",
    grvSubtitle: "VHRP कडे समस्या किंवा तक्रार नोंदवा.",
    grvSubject: "विषय *",
    grvSubjectPh: "थोडक्यात शीर्षक",
    grvCategory: "श्रेणी",
    grvLocation: "ठिकाण (शहर, राज्य)",
    grvLocationPh: "उदा. पुणे, महाराष्ट्र",
    grvDesc: "समस्येचे वर्णन करा *",
    grvDescPh: "कृपया संपूर्ण माहिती द्या — काय झाले, केव्हा आणि कोण सामील होते.",
    grvSubmit: "तक्रार सबमिट करा",
    grvFillReq: "कृपया विषय आणि वर्णन भरा",
    grvOkTitle: "तक्रार प्राप्त झाली",
    grvOkSub: "तुमची तक्रार नोंदवली गेली आहे. आमची टीम 3 कामकाजाच्या दिवसांत संपर्क करेल.",
    grvTicket: "तिकीट आयडी",
    grvAnother: "आणखी एक तक्रार नोंदवा",
    catLand: "जमीन वाद",
    catCorruption: "भ्रष्टाचार",
    catPublic: "सार्वजनिक सेवा",
    catWomen: "महिला सुरक्षा",
    catCommunal: "जातीय समस्या",
    catOther: "इतर",
    regTitle: "सदस्यत्व तपशील",
    regTierLabel: "स्तर",
    regPhotoAdd: "फोटो जोडा",
    regPhotoHint: "पासपोर्ट फोटो (3:4)\nतुमच्या डिजिटल ओळखपत्रावर वापरला जाईल.",
    regFullName: "पूर्ण नाव *",
    regFather: "वडील / पालकांचे नाव *",
    regAddress: "पत्ता *",
    regPhone: "फोन *",
    regDob: "जन्मतारीख *",
    regEmail: "ईमेल",
    regDesignation: "पद",
    regBlood: "रक्तगट",
    regAadhaar: "आधार क्रमांक *",
    regPay: "पेमेंटकडे पुढे चला",
    regFillReq: "कृपया सर्व आवश्यक फील्ड भरा",
    regPhotoPerm: "फोटो परवानगी आवश्यक",
    regDefaultDesig: "सामान्य सदस्य",
    payTitle: "पेमेंट",
    payCreating: "तुमची ऑर्डर तयार होत आहे…",
    payAmount: "देय रक्कम",
    payDemo: "डेमो मोड: Razorpay की कॉन्फिगर केलेल्या नाहीत. \"पे\" दाबल्यास यशस्वी पेमेंट सिम्युलेट होईल.",
    paySimulate: "पेमेंट सिम्युलेट करा",
    payNow: "आता पेमेंट करा",
    paySecured: "🔒 Razorpay द्वारे सुरक्षित",
    payProcessing: "पेमेंट प्रक्रियेत आहे…",
    payFailTitle: "पेमेंट अयशस्वी",
    payFailSub: "काहीतरी चूक झाली. पुन्हा प्रयत्न करा.",
    payBack: "मागे जा",
    payOkTitle: "तुम्ही सदस्य झालात! 🎉",
    payOkSub: "पेमेंट मिळाले. तुमचे डिजिटल ओळखपत्र तयार आहे.",
    payViewCard: "माझे डिजिटल कार्ड पहा",
    cardHeadTitle: "माझे डिजिटल ओळखपत्र",
    cardScan: "पडताळणीसाठी स्कॅन करा",
    cardScanHint: "पडताळणी करणारे हा कोड स्कॅन करून तुमचे सक्रिय सदस्यत्व निश्चित करू शकतात.",
    cardEmptyTitle: "सक्रिय सदस्यत्व नाही",
    cardEmptySub: "डिजिटल ओळखपत्र मिळवण्यासाठी नोंदणी पूर्ण करा.",
    cardGet: "सदस्यत्व घ्या",
    dMembershipId: "सदस्यत्व आयडी",
    dTier: "स्तर",
    dFullName: "पूर्ण नाव",
    dFather: "वडिलांचे नाव",
    dDob: "जन्मतारीख",
    dPhone: "फोन",
    dAddress: "पत्ता",
    cardShareMsg: "मी आता विश्व हिंदू रक्षा परिषदेचा सदस्य आहे! सदस्यत्व आयडी:",
    cardOfficialSub: "डिजिटल सदस्यत्व कार्ड",
    cardValidUntil: "वैधता",
    cardSo: "वडील",
    cardBlood: "रक्त",
    cardCity: "शहर",
    cardState: "राज्य",
    profCardSection: "माझे डिजिटल कार्ड",
    profBecome: "सदस्य व्हा",
    profBecomeSub: "काही मिनिटांत अधिकृत डिजिटल ओळखपत्र मिळवा.",
    profComplaints: "माझ्या तक्रारी",
    profMore: "अधिक",
    profAboutItem: "VHRP बद्दल",
    profContactItem: "संपर्क साधा",
    profPrivacy: "गोपनीयता धोरण",
    profLanguageItem: "भाषा / Language",
    profLogout: "लॉग आउट",
    newsHeader: "बातमी",
    verifyTile: "सदस्य पडताळा",
    verifyTitle: "सदस्य पडताळणी",
    verifyIntro: "सदस्याचा QR कोड स्कॅन करून लगेच सदस्यत्वाची खात्री करा. कॅमेरा फक्त स्कॅनिंगसाठी वापरला जातो.",
    verifyEnable: "कॅमेरा सुरू करा आणि स्कॅन करा",
    verifyDeniedMsg: "कॅमेरा परवानगी नाकारली गेली. खाली सदस्यत्व आयडी टाइप करा, किंवा सेटिंग्जमध्ये कॅमेरा सुरू करा.",
    verifyOpenSettings: "सेटिंग्ज उघडा",
    verifyScanHint: "कॅमेरा सदस्याच्या QR कोडवर धरा",
    verifyManual: "किंवा सदस्यत्व आयडी टाका",
    verifyCheck: "पडताळा",
    verifyChecking: "पडताळणी सुरू आहे…",
    verifyValid: "वैध सदस्य",
    verifyExpired: "सदस्यत्व कालबाह्य",
    verifyInvalid: "अवैध सदस्य",
    verifyNotFound: "या आयडीने सदस्य सापडला नाही.",
    verifyScanAgain: "आणखी एक पडताळा",
    verifyWebHint: "कॅमेरा स्कॅनिंग मोबाईल अॅपमध्ये चालते. खाली सदस्यत्व आयडी टाका.",
    cardSave: "इमेज सेव्ह करा",
    cardShare: "शेअर करा",
    cardSaved: "कार्डची इमेज गॅलरीत सेव्ह झाली",
    cardSaveFailed: "कार्ड सेव्ह करता आले नाही",
    cardPermPhotos: "कार्ड गॅलरीत सेव्ह करण्यासाठी फोटो परवानगी द्या",
    trackTitle: "तक्रारीची स्थिती",
    stReceived: "प्राप्त झाली",
    stInReview: "पुनरावलोकनात",
    stResolved: "निराकरण झाले",
    trackDesc: "वर्णन",
    trackLocation: "ठिकाण",
    eventsTitle: "आगामी कार्यक्रम",
    eventsEmpty: "सध्या कोणतेही आगामी कार्यक्रम नाहीत. लवकरच पहा!",
    rsvpGo: "मी उपस्थित राहीन",
    rsvpGoing: "तुम्ही जात आहात ✓",
    attending: "उपस्थित राहणार",
    seeAll: "सर्व पहा",
    renewSoonTitle: "सदस्यत्व लवकरच संपणार आहे",
    renewSoonBody: "तुमचे सदस्यत्व {days} दिवसांत संपेल. डिजिटल ओळखपत्र सक्रिय ठेवण्यासाठी नूतनीकरण करा.",
    renewExpiredTitle: "सदस्यत्व संपले आहे",
    renewExpiredBody: "तुमचे सदस्यत्व संपले आहे. डिजिटल ओळखपत्र पुन्हा सक्रिय करण्यासाठी आत्ताच नूतनीकरण करा.",
    renewCta: "आत्ता नूतनीकरण करा",
    evToday: "आज आहे!",
    evTomorrow: "उद्या आहे!",
    regCity: "शहर *",
    regState: "राज्य *",
    regCountry: "देश",
    regSocial: "सोशल मीडिया लिंक",
    regSocialPh: "उदा. https://facebook.com/yourprofile",
    regAadhaarInvalid: "वैध 12-अंकी आधार क्रमांक टाका",
    otpSend: "OTP पाठवा",
    otpSent: "तुमच्या नंबरवर OTP पाठवला आहे",
    otpEnterPh: "6-अंकी OTP",
    otpVerify: "पडताळा",
    otpVerified: "पडताळले ✓",
    otpDemoNote: "डेमो मोड — तुमचा OTP:",
    otpRequired: "कृपया आधी OTP ने फोन नंबर पडताळा",
    dirTile: "सदस्य डिरेक्टरी",
    dirTotalLabel: "नोंदणीकृत सदस्य",
    dirSearchPh: "नाव, शहर किंवा राज्य शोधा…",
    dirAll: "सर्व",
    dirIndia: "भारत",
    dirIntl: "आंतरराष्ट्रीय",
    dirLockedTitle: "फक्त सदस्यांसाठी",
    dirLockedSub: "सदस्य डिरेक्टरी फक्त सक्रिय सदस्यांसाठी उपलब्ध आहे. भारत आणि परदेशातील VHRP सदस्यांशी जोडण्यासाठी सदस्यत्व घ्या.",
    dirEmpty: "सदस्य सापडले नाहीत",
    grvPhotos: "पुरावा म्हणून फोटो जोडा (ऐच्छिक, कमाल 3)",
    trackPhotos: "जोडलेले फोटो",
  },
};
